<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="100px" class="EL-Form">
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="盘点通道" class="EL-Form-Item">
                        <el-select v-model="mainSearch.whCode" placeholder="请选择" clearable="clearable" filterable>
                            <el-option v-for="item in warehouseList" :key="item.whId" :label="item.whCode + '-' + item.whName" :value="item.whCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="盘点单号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.sckCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="盘点状态" class="EL-Form-Item">
                        <el-select multiple collapse-tags v-model="sckStatusList" placeholder="请选择" clearable="clearable">
                            <!-- <el-option label="创建" value="CREATE" /> -->
                            <el-option label="已下发" value="LSSUED" />
                            <el-option label="进行中" value="EXECUTE" />
                            <el-option label="待处理" value="HANDLE" />
                            <el-option label="完成" value="COMPLETE" />
                            <!-- <el-option label="已处理" value="PROCESSED" /> -->
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="盘点类型" class="EL-Form-Item">
                        <el-select v-model="mainSearch.sckType" placeholder="请选择" clearable="clearable">
                            <el-option label="手动" value="手动" />
                            <el-option label="自动" value="自动" />
                        </el-select>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="clickSelectList()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetMain()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="mainSearch.fcCode">
                    <el-form-item label="盘点方式" class="EL-Form-Item">
                        <el-select v-model="mainSearch.sckWay" placeholder="请选择" clearable="clearable">
                            <el-option label="明盘" value="10" />
                            <el-option label="暗盘" value="20" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="!mainSearch.fcCode">
                    <el-form-item label="盘点方式" class="EL-Form-Item">
                        <el-select v-model="mainSearch.sckWay" placeholder="请选择" clearable="clearable">
                            <el-option label="明盘" value="10" />
                            <el-option label="暗盘" value="20" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="9" :xl="9">
                    <el-form-item label="时间范围" class="EL-Form-Item">
                        <el-date-picker style="width: 350px" v-model="mainSearch.date" value-format="yyyy-MM-dd HH:mm" type="datetimerange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </el-form-item>
                </el-col> -->
            </el-form>
        </box>
        <box fill>
            <plabel text="盘点执行">
                <el-button v-authority="'BACK_MENU3_M18_B1'" class="btn-t-edit" @click="clickTaskUpdate">盘点录入</el-button>
                <el-button v-authority="'BACK_MENU3_M18_B2'" class="btn-t-edit" @click="inventoryProcessingShow">盘点处理</el-button>
                <el-button v-authority="'BACK_MENU3_M18_B3'" class="btn-t-delete" @click="closeInventory">取消任务</el-button>
                <el-button v-authority="'BACK_MENU3_M18_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table :headerCellStyle="mainData.headerCellStyle" style="flex: 1" @pageChange="getStockCheckTaskList" :data="mainData.data" pagination :nowPage.sync="mainData.nowPage" :pageSize.sync="mainData.pageSize" :total.sync="mainData.total" @selectionChange="checkTableMain">
                <el-table-column type="selection" align="center">
                </el-table-column>
                <!-- <el-table-column label="通道编号" align="center" prop="whCode">
                </el-table-column> -->
                <el-table-column label="盘点单号" align="center" prop="sckCode" width="135px">
                </el-table-column>
                <el-table-column label="下发时间" align="center" prop="updateTime" width="140px">
                </el-table-column>
                <!-- <el-table-column label="盘点类型" align="center" prop="sckType">
                </el-table-column> -->
                <el-table-column label="盘点状态" align="center" prop="sckStatus">
                    <template slot-scope="scope">
                        <!-- <span v-if="scope.row.sckStatus == 'CREATE'">创建</span> -->
                        <span v-if="scope.row.sckStatus == 'LSSUED'">已下发</span>
                        <span v-if="scope.row.sckStatus == 'EXECUTE'">进行中</span>
                        <span v-if="scope.row.sckStatus == 'HANDLE'">待处理</span>
                        <!-- <span v-if="scope.row.sckStatus == 'PROCESSED'">已处理</span> -->
                        <span v-if="scope.row.sckStatus == 'COMPLETE'">完成</span>
                        <span v-if="scope.row.sckStatus == 'CLOSE'">关闭</span>
                    </template>
                </el-table-column>
                <el-table-column label="盘点部门" align="center" prop="sckDept">
                </el-table-column>
                <el-table-column label="盘点人员" align="center" prop="sckPerson">
                </el-table-column>
				<el-table-column label="库位" align="center" prop="whCode">
				</el-table-column>
             <!--   <el-table-column label="盘点方式" align="center" prop="sckWay">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sckWay == '10'">明盘</span>
                        <span v-if="scope.row.sckWay == '20'">暗盘</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="预计盘点时间" align="center" prop="sckTime" width="240px">
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime" width="140px">
                </el-table-column>
                <el-table-column label="操作人" align="center" prop="person">
                </el-table-column>
                <el-table-column label="操作" min-width="120" fixed="right" width="140px">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU3_M18_B5'" class="btn-t-edit" @click="rowDetail(scope.row)">明细
                        </el-button>
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 新增实物多余记录 -->
        <el-dialog title="新增实物多余记录" :visible.sync="insertTaskRecordDialog" class="fromDialog" :style="$popups.popups(0.5,0.5)" :before-close="closeTaskRecord">
            <!-- <div> -->
            <el-form :model="insertInventoryData" :rules="rules" ref="insertInventoryData" label-width="80px">
                <el-col :lg="8" :xl="8">
                    <el-form-item label="所属通道" prop="whCode" class="EL-Form-Item">
                        <el-select v-model="insertInventoryData.whCode" placeholder="请选择" filterable clearable="clearable" remote :remote-method="remoteMethodWhCode">
                            <el-option v-for="(item, index) in WhCodeList" :key="index" :label="item.whCode" :value="item.whCode">{{item.whCode}}-{{item.whName}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="所在库位" prop="lcCode" class="EL-Form-Item">
                        <el-select v-model="insertInventoryData.laCode" placeholder="请选择" filterable clearable="clearable" remote :remote-method="remoteMethodLcCode">
                            <el-option v-for="(item, index) in lcCodeList" :key="index" :label="item.lcCode" :value="item.lcCode">{{item.lcCode}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
                        <el-select v-model="insertInventoryData.matCode" placeholder="请选择" filterable clearable="clearable" remote :remote-method="remoteMethod">
                            <el-option v-for="(item, index) in matCodes" :key="index" :label="item.mtCode" :value="item.mtCode" @click.native="matCodeChange(item)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="物料描述" prop="matName" class="EL-Form-Item">
                        <el-input v-model="insertInventoryData.matName" :disabled="true" placeholder="选择物料编号后自动填充">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="数量" prop="matQuan" class="EL-Form-Item">
                        <el-input v-model="insertInventoryData.matQuan" placeholder="请输入数量" oninput="value=value.replace(/[^\d]/g,'')">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="批次号" prop="batchNo" class="EL-Form-Item">
                        <el-input v-model="insertInventoryData.batchNo" placeholder="请输入批次号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="包装箱号" prop="boxBarcode" class="EL-Form-Item">
                        <el-input v-model="insertInventoryData.boxBarcode" placeholder="请输入箱号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="入库时间" prop="matCreateTime" class="EL-Form-Item">
                        <el-date-picker v-model="insertInventoryData.matCreateTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="规值" prop="matSpecs" class="EL-Form-Item">
                        <el-input v-model="insertInventoryData.matSpecs" placeholder="请输入规值"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="订单编号" prop="orderCode" class="EL-Form-Item">
                        <el-input v-model="insertInventoryData.orderCode" placeholder="请输入订单编号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="备注" prop="remarks" class="EL-Form-Item">
                        <el-input v-model="remarks" placeholder="请输入备注"></el-input>
                    </el-form-item>
                </el-col>
            </el-form>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button type="primary" @click="insertStockCheckTaskRecord()" class="btn-t-edit">确定</el-button>
                <el-button @click="resetInsertInventory" class="btn-t-info">重置</el-button>
            </span>
        </el-dialog>

        <!-- 新增盘盈 -->
        <el-dialog title="新增盘盈" :visible.sync="insertInventoryDialog" class="fromDialog" :style="$popups.popups(0.5,0.5)" :before-close="insertInventoryClose">
            <!-- <div> -->
            <el-form :model="insertInventoryData" :rules="rules" ref="insertInventoryData" label-width="80px">
                <el-col :lg="8" :xl="8">
                    <el-form-item label="所属通道" prop="whCode" class="EL-Form-Item">
                        <el-select v-model="insertInventoryData.whCode" placeholder="请选择" filterable clearable="clearable" remote :remote-method="remoteMethodWhCode">
                            <el-option v-for="(item, index) in WhCodeList" :key="index" :label="item.whCode" :value="item.whCode">{{item.whCode}}-{{item.whName}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="所在库位" prop="lcCode" class="EL-Form-Item">
                        <el-select v-model="insertInventoryData.laCode" placeholder="请选择" filterable clearable="clearable" remote :remote-method="remoteMethodLcCode">
                            <el-option v-for="(item, index) in lcCodeList" :key="index" :label="item.lcCode" :value="item.lcCode">{{item.lcCode}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
                        <el-select v-model="insertInventoryData.matCode" placeholder="请选择" filterable clearable="clearable" remote :remote-method="remoteMethod">
                            <el-option v-for="(item, index) in matCodes" :key="index" :label="item.mtCode" :value="item.mtCode" @click.native="matCodeChange(item)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="物料描述" prop="matName" class="EL-Form-Item">
                        <el-input v-model="insertInventoryData.matName" :disabled="true" placeholder="选择物料编号后自动填充">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="数量" prop="matQuan" class="EL-Form-Item">
                        <el-input v-model="insertInventoryData.matQuan" placeholder="请输入数量" oninput="value=value.replace(/[^\d]/g,'')">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="批次号" prop="batchNo" class="EL-Form-Item">
                        <el-input v-model="insertInventoryData.batchNo" placeholder="请输入批次号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="包装箱号" prop="boxBarcode" class="EL-Form-Item">
                        <el-input v-model="insertInventoryData.boxBarcode" placeholder="请输入箱号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="入库时间" prop="matCreateTime" class="EL-Form-Item">
                        <el-date-picker v-model="insertInventoryData.matCreateTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="规值" prop="matSpecs" class="EL-Form-Item">
                        <el-input v-model="insertInventoryData.matSpecs" placeholder="请输入规值"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="订单编号" prop="orderCode" class="EL-Form-Item">
                        <el-input v-model="insertInventoryData.orderCode" placeholder="请输入订单编号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="业务类型" prop="sorTypeSub" class="EL-Form-Item">
                        <el-select v-model.trim="insertInventoryData.sorTypeSub" clearable="clearable" placeholder="请选择">
                            <el-option key="10" value="10" label="赠品入库"></el-option>
                            <el-option key="20" value="20" label="盘盈入库"></el-option>
                            <el-option key="30" value="30" label="其他入库"></el-option>
                            <el-option key="40" value="40" label="盘亏出库"></el-option>
                            <el-option key="50" value="50" label="间材出库"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="8" :xl="8">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-form-item>
                            <el-button type="primary" @click="insertInventory()" class="btn-t-edit">确定</el-button>
                            <el-button @click="resetInsertInventory" class="btn-t-info">重置</el-button>
                        </el-form-item>
                    </el-form-item>
                </el-col> -->
            </el-form>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button type="primary" @click="saveOtherIn()" class="btn-t-edit">确定</el-button>
                <el-button @click="resetInsertInventory" class="btn-t-info">重置</el-button>
            </span>
        </el-dialog>

        <!-- 盘点处理 -->
        <el-dialog title="盘点处理" :visible.sync="inventoryProcessingDialog" class="fromDialog" :style="$popups.popups(0.8,0.98)" :before-close="inventoryProcessingClose">
            <div>
                <el-form label-position="right" label-width="70px">
                    <!-- <el-col :lg="5" :xl="5">
                        <el-form-item label="盘点单号" class="EL-Form-Item">
                            <el-input v-model="inventoryProcessingSearch.sckCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="通道编号" class="EL-Form-Item">
                            <el-select v-model="inventoryProcessingSearch.whCode" placeholder="请选择" clearable="clearable">
                                <el-option v-for="(item, index) in warehouseList" :key="index" :label="item.whCode" :value="item.whCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="库位" class="EL-Form-Item">
                            <el-select v-model="inventoryProcessingSearch.lcCode" filterable placeholder="请选择" clearable="clearable" remote :remote-method="remoteMethodInventoryLcCode">
                                <el-option v-for="(item, index) in lcCodeList" :key="index" :label="item.lcCode" :value="item.lcCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="物料编号" class="EL-Form-Item">
                            <!-- <el-input v-model="checkData.matCode" placeholder="请输入"></el-input> -->
                            <el-select v-model="inventoryProcessingSearch.matCode" placeholder="请选择" clearable="clearable" filterable remote :remote-method="remoteMethod">
                                <el-option v-for="(item, index) in matCodes" :key="index" :label="item.mtCode" :value="item.mtCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :lg="5" :xl="5">
                        <el-form-item label="批次号" class="EL-Form-Item">
                            <el-input v-model="inventoryProcessingSearch.batchNo" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="状态" class="EL-Form-Item">
                            <el-select v-model="inventoryProcessingSearch.status" placeholder="请选择" clearable="clearable">
                                 <el-option label="已盘点" value="COMPLETE" />
                                 <el-option label="未盘点" value="EXECUTE" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="4" :xl="4" class="EL-Form-Item">
                        <el-form-item>
                            <el-button class="btn-t-edit" @click="clickSelectInventoryProcessingList()">查询</el-button>
                            <el-button class="btn-t-delete" @click="resetInventoryProcessingSearch()">重置</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="箱号" class="EL-Form-Item">
                            <el-input v-model="inventoryProcessingSearch.boxBarcode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="盘点人" class="EL-Form-Item">
                            <el-input v-model="inventoryProcessingSearch.person" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="盘点时间" class="EL-Form-Item">
                            <el-date-picker v-model="inventoryProcessingSearch.inventoryTime" value-format="yyyy-MM-dd" placeholder="请选择"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="9" :xl="9" class="EL-Form-Item">
                        <el-button class="btn-t-edit" @click="openTransactionAdjustmentDialog('20')" style="float:right;margin-left:10px">调整</el-button>
                        <el-button class="btn-t-edit" @click="openWhInventoryShow" style="float:right">库存查询</el-button>
                        <el-button class="btn-t-edit" @click="confirmCompletion" style="float:right">确认完成</el-button>
                    </el-col>
                </el-form>
            </div>
            <!-- <el-button :loading="inventorySurplusAndLossLoading" class="btn-t-delete" @click="inventorySurplusAndLoss">
                一键盘点处理
            </el-button> -->
            <div>
                <h-table :headerCellStyle="inventoryProcessingList.headerCellStyle" :style="$popups.harvestRecordStyle(0.32)" @pageChange="
            getStockCheckTaskDetailListNotProfitLoss()
          " :data="inventoryProcessingList.data" pagination :nowPage.sync="inventoryProcessingList.nowPage" :pageSize.sync="inventoryProcessingList.pageSize" :total.sync="inventoryProcessingList.total" @selectionChange="checkInventoryMain">
                    <el-table-column type="selection" align="center"></el-table-column>
                    <el-table-column label="盘点单号" align="center" prop="sckCode"></el-table-column>
                    <el-table-column label="通道" align="center" prop="whCode"></el-table-column>
                    <el-table-column label="物料编号" align="center" prop="matCode"></el-table-column>
                    <!-- <el-table-column label="物料描述" align="center" prop="matName"></el-table-column> -->
                    <el-table-column label="物料数量" align="center" prop="matQuan"></el-table-column>
                    <el-table-column label="实际数量" align="center" prop="matQuanReal" width="100px">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status =='EXECUTE'">

                            </div>
                            <div v-else>
                                {{ scope.row.matQuanReal}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="差异数" align="center" prop="matQuanReal" width="100px">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status =='EXECUTE'">

                            </div>
                            <div v-else-if="scope.row.matQuanReal >= 0">
                                {{ scope.row.matQuanReal - scope.row.matQuan }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="批次号" align="center" prop="batchNo"></el-table-column>
                    <el-table-column label="库位" align="center" prop="laCode"></el-table-column>
                    <!-- <el-table-column label="状态" align="center" prop="status">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 'CREATE'">创建</span>
                        <span v-if="scope.row.status == 'EXECUTE'">进行中</span>
                        <span v-if="scope.row.status == 'COMPLETE'">完成</span>
                    </template>
                </el-table-column> -->
                    <el-table-column label="包装箱号" align="center" prop="boxBarcode"></el-table-column>
                    <el-table-column label="状态" align="center" prop="status">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 'COMPLETE'">已盘点</span>
                            <span v-if="scope.row.status == 'EXECUTE'">未盘点</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="处理后的数量" align="center" prop="matDealQuan"></el-table-column> -->
                    <!-- <el-table-column label="是否盘点处理" align="center" prop="dealFlag">
                        <template slot-scope="scope">
                            <span v-if="scope.row.dealFlag == true">是</span>
                            <span v-if="scope.row.dealFlag == false">否</span>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column label="盘点处理时间" align="center" prop="dealTime"></el-table-column> -->
                    <el-table-column label="是否新增盘盈" align="center" prop="profitFlag">
                        <template slot-scope="scope">
                            <span v-if="scope.row.profitFlag == true">是</span>
                            <span v-if="scope.row.profitFlag == false">否</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="备注" align="center" prop="remark"></el-table-column> -->
                    <el-table-column label="盘点时间" align="center" prop="updateTime"></el-table-column>
                    <el-table-column label="盘点人" align="center" prop="person"></el-table-column>
                    <!-- <el-table-column label="更新时间" align="center" prop="updateTime"></el-table-column> -->
                    <!-- <el-table-column label="操作" min-width="160" fixed="right">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.matQuanReal - scope.row.matQuan > 0" class="btn-t-edit" @click="inventorySurplus(scope.row)" :disabled="scope.row.dealFlag == false ? false : true">盘盈处理</el-button>
                            <el-button v-if="scope.row.matQuanReal - scope.row.matQuan < 0" class="btn-t-edit" @click="inventoryLoss(scope.row)" :disabled="scope.row.dealFlag == false ? false : true">盘亏处理</el-button>
                        </template>
                    </el-table-column> -->
                </h-table>
            </div>
            <hr>
            <div>
                <span style="float:left;font-size:18px;margin:5px 0px 10px 15px">盘点实物多余记录</span>
                <!-- <hr style="color:#ccc"/> -->
                <h-table :headerCellStyle="detailData.headerCellStyle" :style="$popups.harvestRecordStyle(0.32)" @pageChange="
            getStockCheckTaskRecord()
          " :data="stockCheckTaskRecord.data" pagination :nowPage.sync="stockCheckTaskRecord.nowPage" :pageSize.sync="stockCheckTaskRecord.pageSize" :total.sync="stockCheckTaskRecord.total">
                    <!-- <el-table-column type="selection"  align="center" :selectable='checkboxDetail'></el-table-column> -->
                    <el-table-column label="盘点单号" align="center" prop="sckCode"></el-table-column>
                    <el-table-column label="通道" align="center" prop="whCode"></el-table-column>
                    <el-table-column label="物料编号" align="center" prop="matCode"></el-table-column>
                    <!-- <el-table-column label="物料描述" align="center" prop="matName"></el-table-column> -->
                    <el-table-column label="物料数量" align="center" prop="matQuan"></el-table-column>
                    <el-table-column label="批次号" align="center" prop="batchNo"></el-table-column>
                    <el-table-column label="库位" align="center" prop="laCode"></el-table-column>
                    <el-table-column label="包装箱号" align="center" prop="boxBarcode"></el-table-column>
                    <el-table-column label="规值" align="center" prop="matSpecs"></el-table-column>
                    <el-table-column label="订单编号" align="center" prop="orderCode"></el-table-column>
                    <el-table-column label="生产日期" align="center" prop="matCreateTime"></el-table-column>
                    <el-table-column label="是否新增盘盈" align="center" prop="profitFlag">
                        <template slot-scope="scope">
                            <span v-if="scope.row.profitFlag == true">是</span>
                            <span v-if="scope.row.profitFlag == false">否</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="备注" align="center" prop="remark"></el-table-column>
                    <el-table-column label="创建时间" align="center" prop="createTime"></el-table-column>
                    <el-table-column label="操作人" align="center" prop="person"></el-table-column>
                    <el-table-column label="操作人工号" align="center" prop="personNumber"></el-table-column>
                    <el-table-column label="操作" min-width="180" fixed="right">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.profitFlag == false" class="btn-t-edit" @click="setInsertInventoryWin(scope.row)">
                                新增盘盈
                            </el-button>
                            <el-button v-else-if="scope.row.profitFlag == true" class="btn-t-edit" @click="setInsertInventoryWin(scope.row)" disabled>
                                新增盘盈
                            </el-button>
                            <el-button class="btn-t-delete" @click="deleteInventoryRecord(scope.row)">
                                删除
                            </el-button>
                        </template>

                    </el-table-column>
                </h-table>
            </div>
            <!-- <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="inventoryProcessingClose" type="info" class="btn-t-info">关 闭</el-button>
                <el-button :loading="processingCompleteLoading" class="btn-t-delete" @click="processingComplete()">
                    处理完成
                </el-button>
            </div> -->
        </el-dialog>

        <!-- 详情框 -->
        <el-dialog title="详情" :visible.sync="detailShow" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false" :show-close="false">
            <div>
                <el-form label-position="right" label-width="80px">
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="通道编号" class="EL-Form-Item">
                            <!-- <el-input v-model="checkData.whCode" disabled></el-input> -->
                            <el-select v-model="detailsSearch.whCode" placeholder="请选择" clearable="clearable">
                                <el-option v-for="(item, index) in warehouseList" :key="index" :label="item.whCode" :value="item.whCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="货位号" class="EL-Form-Item">
                            <!-- <el-select v-model="detailsSearch.lcCodeByLcType" placeholder="请选择" clearable="clearable" filterable remote :remote-method="remoteMethodLcType">
                                <el-option v-for="(item, index) in lcCodeByLcTypeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                                </el-option>
                            </el-select> -->
                            <el-input v-model="detailsSearch.lcCodeByLcType" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="物料编号" class="EL-Form-Item">
                            <el-input v-model="detailsSearch.matCode" placeholder="请输入"></el-input>
                            <!-- <el-select v-model="detailsSearch.matCode" placeholder="请选择" clearable="clearable" filterable remote :remote-method="remoteMethod">
                                <el-option v-for="(item, index) in matCodes" :key="index" :label="item.mtCode" :value="item.mtCode">
                                </el-option>
                            </el-select> -->
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="批次号" class="EL-Form-Item">
                            <!-- <el-input v-model="checkData.batchNo" disabled></el-input> -->
                            <el-input v-model="detailsSearch.batchNo" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :lg="6" :xl="6">
                        <el-form-item label="盘点部门" class="EL-Form-Item">
                            <el-input v-model="checkData.sckDept" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="盘点人员" class="EL-Form-Item">
                            <el-select v-model="detailsSearch.person" placeholder="请选择" clearable="clearable" filterable>
                                <el-option v-for="(item, index) in userList" :key="index" :label="item.userAccount + '-' + item.userName" :value="item.userAccount">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="盘点时间" class="EL-Form-Item">
                            <el-input v-model="checkData.sckTime" disabled></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="状态" class="EL-Form-Item">
                            <el-select v-model="detailsSearch.status" placeholder="请选择" clearable="clearable" filterable>
                                <el-option label="进行中" value="EXECUTE" />
                                <el-option label="完成" value="COMPLETE,PROCESSED" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="箱号" class="EL-Form-Item">
                            <!-- <el-input v-model="checkData.batchNo" disabled></el-input> -->
                            <el-input v-model="detailsSearch.boxBarcode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="盘点人" class="EL-Form-Item">
                            <!-- <el-input v-model="checkData.batchNo" disabled></el-input> -->
                            <el-input v-model="detailsSearch.person" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :lg="6" :xl="6" class="EL-Form-Item">
                        <el-form-item>
                            <el-button class="btn-t-edit" @click="clickSelectDetailList()">查询</el-button>
                            <el-button class="btn-t-delete" @click="resetStockDetail()">重置</el-button>
                        </el-form-item>
                    </el-col> -->
                </el-form>
            </div>
            <div>
                <h-table :headerCellStyle="detailData.headerCellStyle" :style="$popups.harvestRecordStyle(0.64)" @pageChange="getStockCheckTaskDetailList" :data="detailData.data" pagination :nowPage.sync="detailData.nowPage" :pageSize.sync="detailData.pageSize" :total.sync="detailData.total">
                    <el-table-column label="盘点单号" align="center" prop="sckCode">
                    </el-table-column>
                    <el-table-column label="通道" align="center" prop="whCode">
                    </el-table-column>
                    <el-table-column label="物料编号" align="center" prop="matCode" >
                    </el-table-column>
                    <el-table-column label="物料描述" align="center" prop="matName" min-width="150">
                    </el-table-column>
                    <el-table-column label="物料数量" align="center" prop="matQuan">
                        <template slot-scope="scope">
                            <div v-if="detailData.data.length && detailData.data[0].sckWay == '10'">
                                {{ scope.row.matQuan }}
                            </div>
                            <div v-else-if="checkData.sckStatus != 'LSSUED' && checkData.sckStatus != 'EXECUTE'">
                                {{ scope.row.matQuan }}
                            </div>
                            <div v-else>
                                ***
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="实际数量" align="center" prop="matQuanReal" width="100px">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status == 'EXECUTE'">

                            </div>
                            <div v-else>
                                {{ scope.row.matQuanReal }}
                            </div>
                        </template>
                        <!-- <template slot-scope="scope">
              <el-input
                type="number"
                onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                min="1"
                v-if="checkData.sckStatus == 'EXECUTE'"
                v-model="scope.row.matQuanReal"
                @blur="confirmDetail(scope.row)"
                placeholder="请输入"
              ></el-input>
              <div
                v-if="
                  checkData.sckStatus == 'COMPLETE' ||
                  checkData.sckStatus == 'HANDLE'
                "
              >
                {{ scope.row.matQuanReal }}
              </div>
            </template> -->
                    </el-table-column>
                    <el-table-column label="差异数" align="center" prop="matQuanReal" width="100px">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status == 'EXECUTE'">

                            </div>
                            <div v-else-if="detailData.data.length && detailData.data[0].sckWay == '10'">
                                {{ scope.row.matQuanReal - scope.row.matQuan }}
                            </div>
                            <div v-else-if="checkData.sckStatus != 'LSSUED' && checkData.sckStatus != 'EXECUTE'">
                                {{ scope.row.matQuanReal - scope.row.matQuan }}
                            </div>
                            <div v-else>
                                ***
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="批次号" align="center" prop="batchNo">
                    </el-table-column>
                    <el-table-column label="库位" align="center" prop="laCode">
                    </el-table-column>
                    <el-table-column label="状态" align="center" prop="status">
                        <template slot-scope="scope">
                            <!-- <span v-if="scope.row.status == 'CREATE'">创建</span> -->
                            <span v-if="scope.row.status == 'LSSUED'">已下发</span>
                            <span v-if="scope.row.status == 'EXECUTE'">进行中</span>
                            <span v-if="scope.row.status == 'HANDLE'">待处理</span>
                            <!-- <span v-if="scope.row.status == 'PROCESSED'">已处理</span> -->
                            <span v-if="scope.row.status == 'COMPLETE'">完成</span>
                            <span v-if="scope.row.status == 'PROCESSED'">完成</span>
                            <span v-if="scope.row.status == 'CLOSE'">关闭</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="包装箱号" align="center" prop="boxBarcode" min-width="100">
                    </el-table-column>
                    <el-table-column label="订单编号" align="center" prop="orderCode">
                    </el-table-column>
                    <el-table-column label="规值" align="center" prop="matSpecs">
                    </el-table-column>
                    <!-- <el-table-column label="备注" align="center" prop="remark">
                    </el-table-column> -->
                    <!-- <el-table-column label="处理后的数量" align="center" prop="matDealQuan"></el-table-column> -->
                    <!-- <el-table-column label="是否盘点处理" align="center" prop="dealFlag">
                        <template slot-scope="scope">
                            <span v-if="scope.row.dealFlag == true">是</span>
                            <span v-if="scope.row.dealFlag == false">否</span>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column label="盘点处理时间" align="center" prop="dealTime"></el-table-column> -->
                    <el-table-column label="是否新增盘盈" align="center" prop="profitFlag">
                        <template slot-scope="scope">
                            <span v-if="scope.row.profitFlag == true">是</span>
                            <span v-if="scope.row.profitFlag == false">否</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间" align="center" prop="createTime">
                    </el-table-column>
                    <el-table-column label="盘点人" align="center" prop="person">
                    </el-table-column>
                    <!-- <el-table-column label="更新时间" align="center" prop="updateTime">
                    </el-table-column> -->
                </h-table>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="detailClose" type="info" class="btn-t-info">关 闭</el-button>
            </div>
        </el-dialog>

        <!-- 盘点录入框 -->
        <el-dialog title="盘点录入" :visible.sync="detailUpdateShow" class="fromDialog" :style="$popups.popups(0.8,0.9)" :before-close="closeDetailUpdateShow">
            <div>
                <el-form label-position="right" label-width="100px">
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="通道编号" class="EL-Form-Item">
                            <!-- <el-select v-model="detailsSearch.whCode" placeholder="请选择" clearable="clearable">
                                <el-option v-for="(item, index) in warehouseList" :key="index" :label="item.whCode" :value="item.whCode"></el-option>
                            </el-select> -->
                            <el-input v-model="detailsSearch.whCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="货位号" class="EL-Form-Item">
                            <!-- <el-select v-model="detailsSearch.lcCodeByLcType" placeholder="请选择" clearable="clearable" filterable remote :remote-method="remoteMethodLcType">
                                <el-option v-for="(item, index) in lcCodeByLcTypeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                                </el-option>
                            </el-select> -->
                            <el-input v-model="detailsSearch.lcCodeByLcType" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="物料编号" class="EL-Form-Item">
                            <!-- <el-input v-model="checkData.matCode" placeholder="请输入"></el-input> -->
                            <!-- <el-select v-model="detailsSearch.matCode" placeholder="请选择" clearable="clearable" filterable>
                                <el-option v-for="(item, index) in matCodes" :key="index" :label="item.mtCode" :value="item.mtCode">
                                </el-option>
                            </el-select> -->
                            <el-input v-model="detailsSearch.matCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="批次号" class="EL-Form-Item">
                            <!-- <el-input v-model="checkData.batchNo" disabled></el-input> -->
                            <el-input v-model="detailsSearch.batchNo" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="状态" class="EL-Form-Item">
                            <!-- <el-input v-model="checkData.batchNo" disabled></el-input> -->
                            <!-- <el-input v-model="detailsSearch.status" placeholder="请输入"></el-input> -->
                            <el-select v-model="detailsSearch.status" placeholder="请选择" clearable="clearable" filterable>
                                <el-option label="进行中" value="EXECUTE" />
                                <el-option label="完成" value="COMPLETE,PROCESSED" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="箱号" class="EL-Form-Item">
                            <!-- <el-input v-model="checkData.batchNo" disabled></el-input> -->
                            <el-input v-model="detailsSearch.boxBarcode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="盘点人" class="EL-Form-Item">
                            <!-- <el-input v-model="checkData.batchNo" disabled></el-input> -->
                            <el-input v-model="detailsSearch.person" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :lg="6" :xl="6">
                        <el-form-item label="盘点部门" class="EL-Form-Item">
                            <el-input v-model="checkData.sckDept" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="盘点人员" class="EL-Form-Item">
                            <el-input v-model="checkData.sckPerson" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="盘点时间" class="EL-Form-Item">
                            <el-input v-model="checkData.sckTime" disabled></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :lg="6" :xl="6">
                        <el-form-item class="btn-edit-delete EL-Form-Item">
                            <el-button class="btn-t-edit" @click="clickOpenTaskRecord()" style="float:right">新增多余实物</el-button>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <div>
                <h-table :headerCellStyle="detailData.headerCellStyle" :style="$popups.harvestRecordStyle(0.64)" @pageChange="getStockCheckTaskDetailList" :data="detailData.data" pagination :nowPage.sync="detailData.nowPage" :pageSize.sync="detailData.pageSize" :total.sync="detailData.total">
                    <el-table-column label="通道编号" align="center" prop="whCode">
                    </el-table-column>
                    <el-table-column label="物料编号" align="center" prop="matCode">
                    </el-table-column>
                    <el-table-column label="物料描述" align="center" prop="matName">
                    </el-table-column>
                    <!-- v-if="detailData.data.length && detailData.data[0].sckWay == '10'" -->
                    <el-table-column label="物料数量" align="center" prop="matQuan">
                        <template slot-scope="scope">
                            <div v-if="detailData.data.length && detailData.data[0].sckWay == '10'">
                                {{ scope.row.matQuan }}
                            </div>
                            <div v-else>
                                ***
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="实际数量" align="center" prop="matQuanReal" width="100px">
                        <template slot-scope="scope">
                            <el-input type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="1" v-if="checkData.sckStatus == 'EXECUTE' || checkData.sckStatus == 'LSSUED'" v-model="scope.row.matQuanReal" @blur="confirmDetail(scope.row)" placeholder="请输入" width="150px"></el-input>
                            <div v-if="
                  checkData.sckStatus == 'COMPLETE' ||
                  checkData.sckStatus == 'HANDLE'
                ">
                                {{ scope.row.matQuanReal }}
                            </div>
                        </template>
                    </el-table-column>
                    <!-- v-if="detailData.data.length && detailData.data[0].sckWay == '10'" -->
                    <el-table-column label="差异数" align="center" prop="matQuanReal" width="100px">
                        <template slot-scope="scope">
                            <div v-if="detailData.data.length && detailData.data[0].sckWay == '10'">
                                {{ scope.row.matQuanReal - scope.row.matQuan }}
                            </div>
                            <div v-else>
                                ***
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="批次号" align="center" prop="batchNo">
                    </el-table-column>
                    <el-table-column label="库位" align="center" prop="laCode">
                    </el-table-column>
                    <el-table-column label="盘点单号" align="center" prop="sckCode">
                    </el-table-column>
                    <el-table-column label="状态" align="center" prop="status">
                        <template slot-scope="scope">
                            <!-- <span v-if="scope.row.status == 'CREATE'">创建</span> -->
                            <span v-if="scope.row.status == 'LSSUED'">已下发</span>
                            <span v-if="scope.row.status == 'EXECUTE'">进行中</span>
                            <span v-if="scope.row.status == 'HANDLE'">待处理</span>
                            <!-- <span v-if="scope.row.status == 'PROCESSED'">已处理</span> -->
                            <span v-if="scope.row.status == 'COMPLETE'">完成</span>
                            <span v-if="scope.row.status == 'PROCESSED'">已处理</span>
                            <span v-if="scope.row.status == 'CLOSE'">关闭</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="包装箱号" align="center" prop="boxBarcode">
                    </el-table-column>
                    <el-table-column label="规值" align="center" prop="matSpecs">
                    </el-table-column>
                    <!-- <el-table-column label="备注" align="center" prop="remark">
                    </el-table-column> -->
                    <el-table-column label="创建时间" align="center" prop="createTime">
                    </el-table-column>
                    <el-table-column label="更新时间" align="center" prop="updateTime">
                    </el-table-column>
                    <el-table-column label="盘点人" align="center" prop="person">
                    </el-table-column>
                </h-table>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button type="info" class="btn-t-info" @click="closeDetailUpdateShow">关 闭</el-button>
                <el-button type="primary" class="btn-t-edit" @click="complete">完 成</el-button>
            </div>
            <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="detailClose" type="info">关 闭</el-button>
      </div> -->
        </el-dialog>

        <!-- 报表框 -->
        <el-dialog title="报表统计" :visible.sync="reportFormShow" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false" :show-close="false">
            <div>
                <el-form label-position="right" label-width="80px">
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="工厂编号" class="EL-Form-Item">
                            <el-input v-model="checkData.fcCode" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="通道编号" class="EL-Form-Item">
                            <el-input v-model="checkData.whCode" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="物料编号" class="EL-Form-Item">
                            <el-input v-model="checkData.matCode" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="批次号" class="EL-Form-Item">
                            <el-input v-model="checkData.batchNo" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="盘点部门" class="EL-Form-Item">
                            <el-input v-model="checkData.sckDept" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="盘点人员" class="EL-Form-Item">
                            <el-input v-model="checkData.sckPerson" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="盘点时间" class="EL-Form-Item">
                            <el-input v-model="checkData.sckTime" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <div>
                <h-table :headerCellStyle="reportFormData.headerCellStyle" :style="$popups.harvestRecordStyle(0.6)" @pageChange="getStockCheckTaskDetailStatistics" :data="reportFormData.data" pagination :nowPage.sync="reportFormData.nowPage" :pageSize.sync="reportFormData.pageSize" :total.sync="reportFormData.total">
                    <!-- <el-table-column
            type="selection"
            align="center"
            :selectable="checkboxDetail"
          >
          </el-table-column> -->
                    <el-table-column label="来源通道" align="center" prop="whCode">
                    </el-table-column>
                    <el-table-column label="物料编号" align="center" prop="matCode">
                    </el-table-column>
                    <el-table-column label="盘点记录数" align="center" prop="inventoryCount">
                    </el-table-column>
                    <el-table-column label="物料总数量" align="center" prop="matQuanSum">
                    </el-table-column>
                    <el-table-column label="盘盈" align="center" prop="maxQuan">
                        <template slot-scope="scope">
                            {{ scope.row.maxQuan >= 0 ? scope.row.maxQuan : 0 }}
                        </template>
                    </el-table-column>
                    <el-table-column label="盘亏" align="center" prop="minQuan">
                        <template slot-scope="scope">
                            {{ scope.row.minQuan >= 0 ? 0 : scope.row.minQuan }}
                        </template>
                    </el-table-column>
                </h-table>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="reportFormClose" type="info" class="btn-t-info">关 闭</el-button>
            </div>
        </el-dialog>

        <!-- 重新盘点-->
        <el-dialog title="重新盘点" :visible.sync="reloadCheckShow" :close-on-click-modal="false" :show-close="false" class="fromDialog" :style="$popups.popups(0.5,0.3)">
            <div>
                <el-form label-position="right" label-width="90px">
                    <!-- <el-col :span="16">
                        <el-form-item label="盘点时间">
                            <el-date-picker v-model="relaodCheckTime" value-format="yyyy-MM-dd HH:mm" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                        </el-form-item>
                    </el-col> -->
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="开始日期" class="EL-Form-Item">
                            <el-date-picker v-model="relaodCheckTime[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions1"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="结束日期" class="EL-Form-Item">
                            <el-date-picker v-model="relaodCheckTime[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions2"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="reloadCheckShow = false" type="info" class="btn-t-info">取 消</el-button>
                <el-button @click="reloadCheckTask" type="primary" class="btn-t-edit">重新盘点</el-button>
            </div>
        </el-dialog>

        <!-- 库存查询 -->
        <el-dialog title="库存查询" :visible.sync="whInventoryShow" class="fromDialog" :style="$popups.popups(0.8,0.8)" :close-on-click-modal="false" :show-close="false">
            <div>

            </div>
            <h-table :headerCellStyle="whInventoryList.headerCellStyle" :style="$popups.harvestRecordStyle(0.57)" @pageChange="getStockList()" :data="whInventoryList.data" pagination :nowPage.sync="whInventoryList.nowPage" :pageSize.sync="whInventoryList.pageSize" :total.sync="whInventoryList.total" ref="hTable">
                <!-- <el-table-column type="selection" align="center">
                </el-table-column> -->
                <el-table-column label="通道编号" align="center" prop="whCode">
                </el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode">
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName">
                </el-table-column>
                <el-table-column label="物料数量" align="center" prop="matQuan">
                </el-table-column>
                <el-table-column label="批次号" align="center" prop="batchNo">
                </el-table-column>
                <el-table-column label="库位" align="center" prop="lcCode">
                </el-table-column>
                <!-- <el-table-column label="订单编号" align="center" prop="orderCode">
                </el-table-column> -->
                <el-table-column label="包装箱号" align="center" prop="boxBarcode">
                </el-table-column>
                <el-table-column label="规值" align="center" prop="matSpecs">
                </el-table-column>
                <el-table-column label="物料状态" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                        <span v-if="scope.row.wiStatus == 'FREEZE'">冻结</span>
                        <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
                        <span v-if="scope.row.wiStatus == 'DELETE'">作废</span>
                        <span v-if="scope.row.wiStatus == 'AGFREEZE'">人工冻结</span>
                    </template>
                </el-table-column>
                <el-table-column label="入库时间" align="center" prop="createTime" width="100px">
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeWhInventoryShow()" class="btn-t-info" type="info">取 消</el-button>
                <el-button :loading="insertStockCheckTaskByParams" v-authority="'BACK_MENU3_M18_B6'" class="btn-t-edit" @click="insertStockCheckTaskByParam()">新增盘点单</el-button>
            </div>
        </el-dialog>

        <!-- 调整 -->
        <el-dialog title="调整" :visible.sync="transactionAdjustmentDialog" class="fromDialog" :style="$popups.popups(0.8,0.8)" :close-on-click-modal="false" :show-close="false">
            <div>
                <el-form label-position="right" label-width="80px">
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="调整类型" class="EL-Form-Item">
                            <el-select v-model="adjustmentType" placeholder="请选择" clearable="clearable" filterable v-if="disableFlag == '20'" @change="changeType">
                                <el-option label="交易类型" value="transactionAdjustment" />
                                <el-option label="移库调整" value="transferAdjustment" />
                            </el-select>
                            <el-select v-model="adjustmentType" placeholder="请选择" clearable="clearable" disabled filterable v-if="disableFlag == '10'">
                                <el-option label="交易类型" value="transactionAdjustment" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="交易类型" class="EL-Form-Item" v-if="adjustmentType == 'transactionAdjustment'">
                            <el-select v-model="transactionType" placeholder="请选择" clearable="clearable" filterable  @change="adjustmentNumber">
                                <el-option key="10" value="IA" label="IA"></el-option>
                                <el-option key="20" value="IS" label="IS"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="原因" prop="sorTypeSub" class="EL-Form-Item" v-if="adjustmentType == 'transactionAdjustment'">
                            <el-select v-model="reasonCode" clearable="clearable" filterable placeholder="请选择" >
                                <el-option :value="item.reasonCode" :label="item.reasonCode +'-'+ item.reasonDescription" :key="index" v-for="(item, index) in transationReasonData"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="库位号" class="EL-Form-Item" v-if="adjustmentType == 'transferAdjustment'">
                            <el-select v-model="transferLcCode" placeholder="请选择" filterable remote :remote-method="remoteMethodLcCodeAll">
                                <el-option v-for="(item, index) in transferLcCodeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <h-table :headerCellStyle="whInventoryList.headerCellStyle" :style="$popups.harvestRecordStyle(0.57)" :data="checkInventorMain" ref="hTable">
                <!-- <el-table-column type="selection" align="center">
                </el-table-column> -->
                <el-table-column label="通道编号" align="center" prop="whCode">
                </el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode">
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName">
                </el-table-column>
                <el-table-column label="物料数量" align="center" prop="matQuan">
                </el-table-column>
                <el-table-column label="调整数量" align="center">
                    <template slot-scope="scope">
                        <div v-if="transactionType == ''">
                            ***
                        </div>
                        <div v-else>
                            {{ scope.row.adjustmentQuan}}
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="盘点数量" align="center" prop="matQuanReal" v-if="transferAdjustment == '20'">
                </el-table-column> -->
                <el-table-column label="批次号" align="center" prop="batchNo">
                </el-table-column>
                <el-table-column label="库位" align="center" prop="laCode">
                </el-table-column>
                <el-table-column label="包装箱号" align="center" prop="boxBarcode">
                </el-table-column>
                <el-table-column label="规值" align="center" prop="matSpecs">
                </el-table-column>
                <el-table-column label="入库时间" align="center" prop="createTime" width="100px">
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeTransactionAdjustmentDialog()" class="btn-t-info" type="info">取 消</el-button>
                <el-button :loading="transferLoading" v-authority="'BACK_MENU3_M18_B7'" class="btn-t-edit" @click="confirmAdjustment()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    let id = 0;
    import confluenceVue from "../reportData/confluence.vue";
    export default {
        name: "StockTakeProject",
        data() {
            return {
                mainSearch: {
                    fcCode: localStorage.getItem("fcCode") || "",
                    sckCode: "",
                    whCode: "",
                    sckStatus: "",
                    sckType: "",
                    sckTypeSub: "",
                    sckWay: "",
                    date: [],
                },
                whCodeId: "",
                warehouseList: [],
                mainData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                detailsSearch: {
                    sckCode: "",
                    matCode: "",
                    matName: "",
                    batchNo: "",
                    whCode: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    status: "",
                    boxBarcode: "",
                    person: "",
                    lcCode: "",
                    lcCodeByLcType: "",
                    date: [],
                },
                inventoryProcessingSearch: {
                    sckCode: "",
                    whCode: "",
                    lcCode: "",
                    matCode: "",
                    matName: "",
                    batchNo: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    boxBarcode: "",
                    person: "",
                    inventoryTime: "",
                    status:"",
                },
                inventoryProcessingList: {
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                detailData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                //报表条件查询
                reportFormSearch: {
                    sckCode: "",
                    matCode: "",
                    matName: "",
                    batchNo: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    status: "",
                    boxBarcode: "",
                    date: [],
                },
                //报表数据
                reportFormData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },

                //多选
                checkListMain: [],
                checkListDetail: [],

                //详情框
                detailShow: false,
                //报表框
                reportFormShow: false,
                //盘点修改框
                detailUpdateShow: false,

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注

                checkData: {}, //盘点选中数据
                //详情盘点查询
                detailsMainSearch: {
                    sckCode: "",
                    matCode: "",
                    matName: "",
                    batchNo: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    status: "",
                    boxBarcode: "",
                    date: [],
                },
                //盘点处理弹窗
                inventoryProcessingDialog: false,
                //新增盘盈弹窗
                insertInventoryDialog: false,
                //为盘点处理对象集合
                notInventoryProcessList: [],
                //物料集合
                matCodes: [],
                //新增盘盈对象
                insertInventoryData: {
                    matCode: "",
                    matName: "",
                    batchNo: "",
                    matQuan: "",
                    boxBarcode: "",
                    whCode: "",
                    laCode: "",
                    wiStatus: "NORMAL",
                    matSpecs: "",
                    matLenValu: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    scdId: "", //用于存储临时变量
                },
                //级联菜单数据
                options: [],
                sckCode: "",
                person: localStorage.getItem("user"),
                personNumber: localStorage.getItem("empNumber"),
                //重新盘点弹窗
                reloadCheckShow: false,
                //重新盘点时间
                relaodCheckTime: [],

                //库区集合
                WhCodeList: [],
                //库位集合
                lcCodeList: [],

                //交易原因
                transationReasonData: [],
                //交易原因
                reasonCode:"",

                //校验
                rules: {
                    whCode: [{
                        required: true,
                        message: "请选择通道编号",
                        trigger: "blur",
                    }, ],
                    laCode: [{
                        required: true,
                        message: "请选中库位",
                        trigger: "blur",
                    }, ],
                    matCode: [{
                        required: true,
                        message: "请选择物料编号",
                        trigger: "blur",
                    }, ],
                    matName: [{
                        required: true,
                        message: "请输入物料描述",
                        trigger: "blur",
                    }, ],
                    batchNo: [{
                        required: true,
                        message: "请输入批次号",
                        trigger: "blur",
                    }, ],
                    // boxBarcode: [{
                    //     required: true,
                    //     message: "请输入箱号",
                    //     trigger: "blur",
                    // }, ],
                    matQuan: [{
                        required: true,
                        message: "请输入数量",
                        trigger: "blur",
                    }, ],
                    matCreateTime: [{
                        required: true,
                        message: '请选择日期',
                        trigger: 'change'
                    }],
                    // matSpecs: [{
                    //     required: true,
                    //     message: "请输入规值",
                    //     trigger: "blur",
                    // }, ],
                    orderCode: [{
                        required: true,
                        message: "请输入订单编号",
                        trigger: "blur",
                    }, ],
                    sorTypeSub: [{
                        required: true,
                        message: "请输入业务类型",
                        trigger: "blur",
                    }, ],
                    // matLenValue: [{
                    //     required: true,
                    //     message: "请输入L值",
                    //     trigger: "blur",
                    // }, ],
                },

                //物料编号loading
                loading: false,
                //远程搜索定时物料编号绑定
                mtCode: "",
                //多选状态数组
                sckStatusList: ["LSSUED","EXECUTE","HANDLE"],
                //远程搜索loading
                lcCodeLoading: false,
                //货位号条件远程搜索
                lcCode: "",
                //远程搜索whCodeLoading
                whCodeLoading: false,
                //通道编号条件远程搜索
                whCode: "",
                //盘点处理按钮加载
                inventorySurplusAndLossLoading: false,
                //处理完成按钮加载
                processingCompleteLoading: false,
                //处理完成flag
                processingCompleteFlag: "",
                //用户集合
                userList: [],
                //盘点单是否全部盘点完提示语
                judgeNotCounted: "",

                //新增实物多余记录窗口
                insertTaskRecordDialog: false,
                //新增实物多余记录备注字段
                remarks:"",

                //库位号集合
                lcCodeByLcTypeList: [],
                //所选库位号
                lcCodeByLcType: "",
                //库位Loading
                lcTypeLoading: false,
                lcTypeLcCode: "",
                //货位类型
                lcType: "",
                //盘点实物多余记录集合
                stockCheckTaskRecord: {
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                //盘点货位集合
                inventoryLcCodeList: [],
                //盘点存在差异值集合
                checkInventorMain: [],
                //新增盘盈确定动态加载
                saveOtherIns: false,

                downloadLoading: false, //下载中
                // 输入框延时加载
                isSetTimeout: null,

                //盘点处理盘点号拼接
                sckCodeList:"",
                //库存查询窗口
                whInventoryShow: false,
                //查询库存集合数据
                whInventoryList: {
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                //库存查询加载
                getStockListLoading: false,
                //工厂
                fcCode: localStorage.getItem("fcCode") || "",
                //库存查询物料拼接
                matCodeList:"",
                //新增盘点单动态加载
                insertStockCheckTaskByParams: false,
                //预计盘点时间 默认当天
                checkTime:[],

                //交易调整框
                transactionAdjustmentDialog:false,
                //调整类型
                adjustmentType: "",
                //交易类型
                transactionType: "",
                //动态加载库位号
                lcCodeLoading: false,
                //调整库位
                transferLcCode:"",
                //库位调整集合
                transferLcCodeList:[],
                //确定调整按钮加载
                transferLoading: false,
                //盘点处理判断条件显示
                disableFlag: "",
                //调整框打开的对象
                adjustmentFlag:"",
            };
        },
        watch: {
            mainSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.clickSelectList(newVal);
                    }, 1000)
                },
                deep: true,
            },
            sckStatusList: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.clickSelectList(newVal);
                    }, 1000)
                },
                deep: true,
            },
            detailsSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.clickSelectDetailList(newVal);
                    }, 1000)
                },
                deep: true,
            },
            inventoryProcessingSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.clickSelectInventoryProcessingList(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        computed: {
            popups() {
                return {
                    overflow: 'hidden',
                    transform: 'translate(-50%, 0)',
                    left: window.innerWidth * 0.5 + "px",
                    top: window.innerHeight * 0.38 + "px",
                    width: window.innerWidth * 0.6 + "px",
                    height: window.innerHeight * 0.22 + "px",
                    "min-width": window.innerWidth * 0.6 + "px",
                    "min-height": window.innerHeight * 0.22 + "px",
                }
            },
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[0]) {
                            return time.getTime() < new Date(_this.mainSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[1]) {
                            return time.getTime() > new Date(_this.mainSearch.date[1]);
                        }
                    }
                }
            },
            pickerOptions1() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.relaodCheckTime[1]) {
                            return time.getTime() > new Date(_this.relaodCheckTime[1]);
                        }
                    }
                }
            },
            pickerOptions2() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.relaodCheckTime[0]) {
                            return time.getTime() < new Date(_this.relaodCheckTime[0]);
                        }
                    }
                }
            },
        },
        methods: {
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy);
                window.lazy = window.setTimeout(() => {
                    this.getStockCheckTaskList();
                }, 1000);
            },
            /**
             * 清空值
             */
            changeType(){
                if(this.adjustmentType == 'transferAdjustment'){
                    this.transactionType = "";
                }
            },
            /**
             * 盘点处理未盘点确认完成
             */
            confirmCompletion(){
                this.$confirm("是否确认完成盘点记录?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.updateStockTaskDetailProcessed();
                    this.getStockCheckTaskDetailListNotProfitLoss();
                    this.getStockCheckTaskRecord();
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
            },
            //获取数据
            getTransaction(type) {
                this.$http
                    .request({
                        url: "/api/transaction/getTransactionAll",
                        method: "GET",
                        params: {
                            transactionType: type,
                            pageNum: 1,
                            pageSize: 100,
                            reasonCode: ''
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.transationReasonData = resp.data.list || [];
                            this.reasonCode = "";
                        }
                    })
                    .catch((error) => {

                    });
            },
            /**
             * 交易类型调整
             */
            adjustmentNumber(){
                if(this.disableFlag == '20'){
                    if(this.transactionType == 'IA'){
                        this.getTransaction("IA");
                        this.checkInventorMain.forEach((item)=>{
                            if(item.status == 'EXECUTE'){
                                item.adjustmentQuan = 0 - item.matQuan;
                            }else{
                                item.adjustmentQuan = item.matQuanReal - item.matQuan;
                            }
                        })
                    }else if(this.transactionType == 'IS'){
                        this.getTransaction("IS");
                        this.checkInventorMain.forEach((item)=>{
                            console.log(item.sckStatus)
                            if(item.status == 'EXECUTE'){
                                item.adjustmentQuan = 0 + item.matQuan;
                            }else{
                                item.adjustmentQuan = item.matQuan - item.matQuanReal;
                            }
                        })
                    }
                }else{
                    if(this.transactionType == 'IA'){
                        this.getTransaction("IA");
                        this.checkInventorMain.forEach((item)=>{
                            item.adjustmentQuan = item.matQuan;
                        })
                    }else if(this.transactionType == 'IS'){
                        this.getTransaction("IS");
                        this.checkInventorMain.forEach((item)=>{
                            item.adjustmentQuan = -item.matQuan;
                        })
                    }
                }

            },
            /**
             * 确认调整
             */
            confirmAdjustment(){
                if (this.adjustmentType == "") {
                    this.$message({
                        type: "warning",
                        message: "请选择调整类型！",
                    });
                    return;
                }
                if(this.adjustmentType == "transactionAdjustment"){
                    if(this.disableFlag == "20"){
                        this.saveOtherOut();
                    }else{
                        this.saveOtherInsert();
                    }
                }else if(this.adjustmentType == "transferAdjustment"){
                    this.insertLocationAdjustment();
                }
            },
            //新增交易IS IA SS
            saveOtherInsert(){
                if (this.adjustmentType == "") {
                    this.$message({
                        type: "warning",
                        message: "请选择调整类型！",
                    });
                    return;
                }
                if (this.transactionType == "") {
                    this.$message({
                        message: "请选择交易类型",
                        type: "warning",
                    });
                    return;
                }
                if (this.reasonCode == "") {
                    this.$message({
                        message: "请选择交易原因",
                        type: "warning",
                    });
                    return;
                }
                this.saveOtherIns = true;
                this.$confirm("是否确认新增交易?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.checkInventorMain.forEach((obj)=>{
                        var type = this.transactionType;
                        if(type == 'IA' || type == 'RW' || type == 'RP' || type == 'RI'){
                            //大于0相加的
                            obj.matQuan = 0 + obj.matQuan;
                        }else if(type == 'IW' || type == 'IS' || type == 'SS' || type == 'VR'){
                            //大于0 需要扣的
                            obj.matQuan = 0 - obj.matQuan;
                        }
                    })
                    this.$http.request({
                        url: "/api/otherRecord/saveOtherInsert",
                        method: "POST",
                        showLoading: true,
                        params:{
                            opearType: this.transactionType,
                            reasonCode: this.reasonCode,
                            person: localStorage.getItem("user"),
                            personNumber:localStorage.getItem("empNumber"),
                        },
                        data: this.checkInventorMain,
                    }).then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "新增成功！",
                                type: "success",
                            });
                            this.updateRecordProfitFlag(this.checkInventorMain[0].scdId);
                            this.checkInventorMain = [];
                            this.getSysLocationAll();
                            this.getStockCheckTaskDetailListNotProfitLoss();
                            this.getStockCheckTaskRecord();
                            this.closeTransactionAdjustmentDialog();
                            this.logRemarks = "otherRecord：新增记录成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "otherRecord：新增记录失败";
                        }
                        this.saveOtherIns = false;
                        //this.logContent = JSON.stringify(this.checkInventorMain);
                        this.systemLog();
                    }).catch((error) => {
                        this.saveOtherIns = false;
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
                }).catch(() => {
                    this.saveOtherIns = false;
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
            },
            /**
             * 交易类型
             */
            saveOtherOut() {
                if (this.adjustmentType == "") {
                    this.$message({
                        type: "warning",
                        message: "请选择调整类型！",
                    });
                    return;
                }
                if (this.transactionType == "") {
                    this.$message({
                        message: "请选择交易类型",
                        type: "warning",
                    });
                    return;
                }
                if (this.reasonCode == "") {
                    this.$message({
                        message: "请选择交易原因",
                        type: "warning",
                    });
                    return;
                }

                var lengthFlag = false;

                var matQuanFlag = false;

                var barcodes = "";

                this.checkInventorMain.forEach((obj) => {
                    if(barcodes == ''){
                        barcodes = obj.boxBarcode;
                    }else{
                        barcodes += "," + obj.boxBarcode;
                    }
                });


                console.log(this.checkInventorMain);
                this.$confirm("是否确认交易类型调整?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                         this.checkInventorMain.forEach((obj) => {
                            //添加操作人，操作工号
                            obj.person = localStorage.getItem('user');
                            obj.personNumber = localStorage.getItem("empNumber");
                            // 添加交易类型
                            obj.sorTypeSub = this.transactionType;
                            console.log(obj.matQuanReal);
                            if(obj.matQuanReal != undefined){
                                if(obj.status == "EXECUTE"){
                                    obj.beforeMatQuan = obj.matQuan;
                                    obj.matQuan = 0;
                                }else{
                                    obj.beforeMatQuan = obj.matQuan;
                                    obj.matQuan = obj.matQuanReal;
                                }
                            }else{
                                obj.beforeMatQuan = 0;
                            }

                        });
                        this.transferLoading = true;
                        this.$http
                            .request({
                                url: "/api/otherRecord/saveOtherOut",
                                method: "POST",
                                showLoading: true,
                                data: this.checkInventorMain,
                                params: {
                                    opearType: this.transactionType,
                                    reasonCode: this.reasonCode,
                                    barcodes: barcodes
                                }
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "调整成功！",
                                        type: "success",
                                    });

                                    this.transactionType = "";
                                    this.checkListMain.forEach((item)=>{
                                        this.sckCodeList += item.sckCode + ",";
                                    })
                                    this.updateStockTaskDetailProcessed();
                                    this.getSysLocationAll();
                                    this.getStockCheckTaskDetailListNotProfitLoss();
                                    this.getStockCheckTaskRecord();
                                    this.closeTransactionAdjustmentDialog();
                                    this.logRemarks = "otherRecord：新增杂出记录成功";
                                } else {
                                    this.$message.error({
                                        title: "失败",
                                        message: resp.message,
                                    });
                                    this.logRemarks = "otherRecord：新增杂出记录失败";
                                }
                                this.transferLoading = false;
                                this.systemLog();
                            })
                            .catch((error) => {
                                this.transferLoading = false;
                                this.$message.error({
                                    title: "失败",
                                    message: "调用失败",
                                });
                            });
                    }).catch(() => {
                        this.transferLoading = false;
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            /**
             * 库位调整
             */
            insertLocationAdjustment(){
                if (this.adjustmentType == "") {
                    this.$message({
                        type: "warning",
                        message: "请选择调整类型！",
                    });
                    return;
                }
                if (this.transferLcCode == "") {
                    this.$message({
                        message: "请选择货位号！",
                        type: "warning",
                    });
                    return;
                }
                this.checkInventorMain.forEach((item)=>{
                    item.traferCode = this.transferLcCode;
                    item.traferWhCode = item.whCode;
                    item.lcCode = item.laCode;
                })
                this.$confirm("是否确认库位调整?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.transferLoading = true;
                        this.$http
                            .request({
                                url: "/api/stockMove/insertStockMove",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    fcCode: this.fcCode, //工厂编号
                                    remark: this.remark, //备注
                                    person: this.person, //库位调整操作人
                                    personNumber: this.personNumber, //库位调整操作人工号
                                },
                                data: this.checkInventorMain, //库位调整集合对象
                            })
                            .then((res) => {
                                if (res.status == 100) {
                                    this.$message({
                                        message: "库位调整成功!",
                                        type: "success",
                                    });
                                    this.logRemarks = "stockMove：新增库位调整成功";
                                    this.checkListMain.forEach((item)=>{
                                        this.sckCodeList += item.sckCode + ",";
                                    })
                                    this.updateStockTaskDetailProcessed();
                                    this.getSysLocationAll();
                                    this.getStockCheckTaskDetailListNotProfitLoss();
                                    this.getStockCheckTaskRecord();
                                    this.closeTransactionAdjustmentDialog();
                                } else {
                                    this.$message({
                                        message: res.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "stockMove：新增库位调整失败";
                                }
                                this.transferLoading = false;
                                this.systemLog();
                            });
                    }).catch(() => {
                        this.insertStockCheckTaskByParams = false;
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            /**
             * 盘点处理明细，修改状态为已处理
             */
            updateStockTaskDetailProcessed(){
                this.$http
                    .request({
                        url: "/api/stockCheckTaskDetail/updateStockTaskDetailProcessed",
                        method: "PUT",
                        data: this.checkInventorMain,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {

                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 远程搜索库位号
             */
            remoteMethodLcCodeAll(query) {
                if (query !== '') {
                    this.lcCodeLoading = true;

                    this.transferLcCode = query;
                    //this.getLcCodeIsCorrect();
                    this.getSysLocationTransfer();

                    setTimeout(() => {
                        this.lcCodeLoading = false;
                        if (this.transferLcCodeList != undefined) {
                            this.transferLcCodeList = this.transferLcCodeList.filter(item => {
                                return item.lcCode.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                            });
                        }
                    }, 200);
                } else {
                    this.transferLcCodeList = [];
                }
            },
            /**
             * 根据用户工厂编号获取所有的库位
             */
            getSysLocationTransfer() {
                this.$http
                    .request({
                        url: "/api/location/getLaCodeAllByType",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            lcCode: this.transferLcCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            console.log("1111")
                            this.transferLcCodeList = resp.data.list;
                            console.log(this.transferLcCodeList)
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 新增盘盈赋值
             */
            setInsertInventoryWin(obj){
                this.checkInventorMain = [obj];
                this.openTransactionAdjustmentDialog("10");
            },
            /**
             * 打开交易调整窗口
             */
            openTransactionAdjustmentDialog(flag){
                this.disableFlag = flag;
                if (this.checkInventorMain.length == 0) {
                    this.$message({
                        message: "请选择需调整的盘点明细！",
                        type: "warning",
                    });
                    return;
                }

                this.getSysLocationTransfer();
                if(flag == "10"){
                    this.adjustmentType = "transactionAdjustment";
                    this.checkInventorMain.forEach((item)=>{
                        item.adjustmentQuan = item.matQuanReal - item.matQuan;
                    })
                }else{
                    this.checkInventorMain.forEach((item)=>{
                        item.adjustmentQuan = item.matQuanReal - item.matQuan;
                    })
                }
                this.transactionAdjustmentDialog = true;
            },
            /**
             * 关闭交易调整窗口
             */
            closeTransactionAdjustmentDialog(){
                this.adjustmentType = "";
                this.transactionType = "";
                this.transferLcCode = "";
                this.disableFlag = "";
                this.transactionAdjustmentDialog = false;
            },
            /**
             * 打开库存查询窗口
             */
            openWhInventoryShow(){
                if (this.checkInventorMain.length == 0) {
                    this.$message({
                        message: "请选择需库存查询的盘点明细！",
                        type: "warning",
                    });
                    return;
                }
                this.checkInventorMain.forEach((item)=>{
                    this.matCodeList += item.matCode + ",";
                })
                this.getStockList();
                this.setTime();
                this.whInventoryShow = true;
            },
            /**
             * 关闭库存查询窗口
             */
            closeWhInventoryShow(){
                this.matCodeList = "";
                this.whInventoryShow = false;
                this.whInventoryList.data = [];
                this.whInventoryList.total = 0;
            },
            //库存列表
            getStockList() {
                this.getStockListLoading = true;
                this.$http
                    .request({
                        url: "/api/inventory/getStockList",
                        method: "GET",
                        params: {
                            pageNum: this.whInventoryList.nowPage, //	页号
                            pageSize: this.whInventoryList.pageSize, //	页大小
                            fcCode: this.fcCode || null, //	工厂编号
                            matCodeList: this.matCodeList || null, //物料类型查询的物料编号集合
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.whInventoryList.data = res.data.list;
                            this.whInventoryList.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                        this.getStockListLoading = false
                    });
            },
                        /**
             * 设置盘点开始日期和结束日期
             */
            setTime(){
                var day1 = new Date();
                day1.setTime(day1.getTime());
                this.checkTime[0] = day1.getFullYear()+"-" + ((day1.getMonth()+1)>10?(day1.getMonth()+1):("0"+(day1.getMonth()+1))) + "-" + day1.getDate() + " 00:00";
                var day2 = new Date();
                day2.setTime(day2.getTime()+24*60*60*1000);
                this.checkTime[1] = day2.getFullYear()+"-" + ((day2.getMonth()+1)>10?(day1.getMonth()+1):("0"+(day1.getMonth()+1))) + "-" + day2.getDate() + " 00:00";
            },
             /**
             * 新增盘点单
             */
            insertStockCheckTaskByParam() {
                if (this.whInventoryList.data.length == 0) {
                    this.$message({
                        message: "没有可盘点的物料！",
                        type: "warning",
                    });
                    return;
                }
                var searchTime = "";
                if (this.checkTime.length > 0) {
                    searchTime = this.checkTime[0] + "," + this.checkTime[1];
                }
                this.$confirm("是否进行盘点?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.insertStockCheckTaskByParams = true;
                        this.$http
                            .request({
                                url: "/api/checkTask/insertStockCheckTaskByList",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    fcCode: localStorage.getItem("fcCode") || null, //	工厂编号
                                    sckTime: searchTime,
                                    person: this.person,
                                    sckWay: "10",
                                    personNumber: this.personNumber,
                                    matCodeList: this.matCodeList,
                                },
                                data: this.whInventoryList.data,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "新增盘点计划成功！",
                                        type: "success",
                                    });
                                    this.logRemarks =
                                        "checkTask：盘点计划（查询盘点）确认将所有的查询结果进行盘点操作成功";
                                    this.checkListMain.forEach((item)=>{
                                        this.sckCodeList += item.sckCode + ",";
                                    })
                                    this.getSysLocationAll();
                                    this.getStockCheckTaskDetailListNotProfitLoss();
                                    this.getStockCheckTaskRecord();
                                    this.closeWhInventoryShow();
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks =
                                        "checkTask：盘点计划（查询盘点）确认将所有的查询结果进行盘点操作失败";
                                }
                                this.insertStockCheckTaskByParams = false;
                                this.logContent = JSON.stringify(this.whInventorySearch);
                                this.systemLog();
                            })
                            .catch((error) => {
                                this.insertStockCheckTaskByParams = false;
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.insertStockCheckTaskByParams = false;
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            /**
             * 打开新增多余实物记录窗口
             */
            clickOpenTaskRecord(){
                this.getSysMaterial();
                this.getSysLocationAll();
                this.getSysWarehouseAllData2();
            },
            /**
             * 插入多余实物记录
             */
            insertStockCheckTaskRecord(){
                if (this.submitForm("insertInventoryData")) {
                    this.insertInventoryData.sckCode = this.checkListMain[0].sckCode
                    this.insertInventoryData.person = this.person;
                    this.insertInventoryData.personNumber = this.personNumber;
                    this.insertInventoryData.remark = this.insertInventoryData.remarks;
                    this.$http
                        .request({
                            url: "/api/checkTask/insertStockCheckTaskRecord",
                            method: "POST",
                            showLoading: true,
                            data: this.insertInventoryData,
                        })
                        .then((resp) => {
                            this.getStockCheckTaskDetailList();
                            this.closeTaskRecord();
                            if (resp.status == 100) {
                                this.$message({
                                    message: "新增多余实物记录成功！",
                                    type: "success",
                                });
                            } else {
                                this.$message({
                                    message: resp.message,
                                    type: "error",
                                });
                            }
                        })
                }
            },
            /**
             * 清空新增多余实物数据
             */
            setInsertInventoryData(){
                this.insertInventoryData = {
                    matCode: "",
                    matName: "",
                    batchNo: "",
                    matQuan: "",
                    boxBarcode: "",
                    whCode: "",
                    laCode: "",
                    wiStatus: "NORMAL",
                    matSpecs: "",
                    matLenValu: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    scdId: "", //用于存储临时变量
                }
            },
            /**
             * 关闭新增多余实物记录窗口
             */
            closeTaskRecord(){
                this.setInsertInventoryData();
                this.$refs.insertInventoryData.clearValidate()
                this.insertTaskRecordDialog = false;
            },
            //新增杂入记录
            saveOtherIn() {
                if (this.submitForm("insertInventoryData")) {
                    this.saveOtherIns = true;
                    this.$confirm("是否确认新增盘盈杂入物料?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        this.$http.request({
                            url: "/api/otherRecord/saveOtherIn",
                            method: "POST",
                            showLoading: true,
                            data: [this.insertInventoryData],
                        }).then((resp) => {
                            if (resp.status == 100) {
                                this.$message({
                                    title: "成功",
                                    message: "新增成功！",
                                    type: "success",
                                });
                                this.updateRecordProfitFlag(this.insertInventoryData.scdId);
                                this.setInventoryDataInit();
                                this.getStockCheckTaskDetailListNotProfitLoss();
                                this.getStockCheckTaskRecord();
                                this.insertInventoryDialog = false;
                                this.logRemarks = "otherRecord：新增杂入记录成功";
                            } else {
                                this.$message.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "otherRecord：新增杂入记录失败";
                            }
                            this.saveOtherIns = false;
                            this.logContent = JSON.stringify(this.mainObj);
                            this.systemLog();
                        }).catch((error) => {
                            this.saveOtherIns = false;
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                    }).catch(() => {
                        this.saveOtherIns = false;
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
                }
            },
            /**
             * 删除盘点实物多余记录
             */
            deleteInventoryRecord(row) {
                this.$confirm(this.processingCompleteFlag + "是否删除该盘点实物多余记录?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/checkTask/deleteInventoryRecord",
                                method: "DELETE",
                                showLoading: true,
                                data: row || [],
                            })
                            .then((resp) => {
                                this.getStockCheckTaskRecord();
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "删除成功！",
                                        type: "success",
                                    });
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                }
                            })
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            /**
             * 修改盘点明细差异值
             */
            updateMatQuanReal() {
                if (this.checkInventorMain.length == 0) {
                    this.$message({
                        message: "请选择需调整的盘点明细！",
                        type: "warning",
                    });
                    return;
                } else{
                    this.$http
                    .request({
                        url: "/api/stockCheckTaskDetail/updateMatQuanReal",
                        method: "PUT",
                        showLoading: true,
                        params:{
                            person: localStorage.getItem("user"),
                        },
                        data: this.checkInventorMain,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$message({
                                message: "修改成功！",
                                type: "success",
                            });
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "error",
                            });
                        }
                        this.clickSelectInventoryProcessingList();
                    })
                }
            },
            /**
             * 处理完成 判断是否还存在未盘点处理和实物新增的
             */
            processingComplete() {
                this.$http
                    .request({
                        url: "/api/checkTask/processingComplete",
                        method: "GET",
                        params: {
                            sckCode: this.checkListMain[0].sckCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status != 100) {
                            this.processingCompleteFlag = "该盘点单还存在为处理的盘盈盘亏或实物多余记录，"
                        } else {
                            this.processingCompleteFlag = "该盘点单已全部盘点处理，"
                        }
                        this.completeStockCheckTask();
                    })
            },
            /**
             * 处理完成，修改该状态为完成
             */
            completeStockCheckTask() {
                this.$confirm(this.processingCompleteFlag + "是否处理完成该盘点单?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/checkTask/completeStockCheckTask",
                                method: "PUT",
                                showLoading: true,
                                params: {
                                    sckCode: this.checkListMain[0].sckCode,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "盘点单处理完成！",
                                        type: "success",
                                    });
                                    this.logRemarks = "checkTask：盘点计划（完成）";
                                    this.getStockCheckTaskList();
                                    this.inventoryProcessingClose();
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "checkTask：盘点计划（完成）";
                                }
                                this.logContent = "sckCode：" + this.checkListMain[0].sckCode;
                                this.systemLog();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            /**
             * 修改盘点单为待处理状态
             */
            pendingInventory() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请选择盘点计划",
                        type: "warning",
                    });
                    return;
                } else if (this.checkListMain.length != 1) {
                    this.$message({
                        message: "只能对一个盘点计划待处理操作",
                        type: "warning",
                    });
                    return;
                } else if (this.checkListMain[0].sckStatus != "COMPLETE") {
                    this.$message({
                        message: "只能对完成状态的盘点计划待处理操作",
                        type: "warning",
                    });
                    return;
                } else {
                    this.$confirm("是否待处理该盘点计划?", "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.$http
                                .request({
                                    url: "/api/checkTask/pendingInventory",
                                    method: "PUT",
                                    showLoading: true,
                                    data: this.checkListMain[0],
                                })
                                .then((resp) => {
                                    if (resp.status == 100) {
                                        this.$message({
                                            message: "操作成功",
                                            type: "success",
                                        });
                                        this.logRemarks = "checkTask：盘点计划（待处理）";
                                        this.getStockCheckTaskList();
                                    } else {
                                        this.$message({
                                            message: resp.message,
                                            type: "error",
                                        });
                                        this.logRemarks = "checkTask：盘点计划（待处理）";
                                    }
                                    this.logContent = "sckCode：" + this.checkListMain[0].sckCode;
                                    this.systemLog();
                                })
                                .catch((error) => {
                                    this.$message({
                                        message: "操作失败:" + error.message,
                                        type: "warning",
                                    });
                                });
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });
                }
            },
            /**
             * 修改盘点实物多余记录的是否新增盘盈
             */
            updateRecordProfitFlag(scdId) {
                this.$http
                    .request({
                        url: "/api/checkTask/updateRecordProfitFlag",
                        method: "PUT",
                        showLoading: true,
                        params: {
                            scdId: scdId,
                        },
                    })
                    .then((resp) => {
                        if (resp.status != 100) {
                            this.$message({
                                message: "修改新增盘盈状态失败",
                                type: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            /**
             * 查询盘点实物多余记录
             */
            getStockCheckTaskRecord() {
                this.$http
                    .request({
                        url: "/api/checkTask/getStockCheckTaskRecord",
                        method: "GET",
                        params: {
                            pageNum: this.stockCheckTaskRecord.nowPage,
                            pageSize: this.stockCheckTaskRecord.pageSize,
                            fcCode: localStorage.getItem("fcCode"),
                            //sckCode: sckCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.stockCheckTaskRecord.data = resp.data.list || null;
                            this.stockCheckTaskRecord.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            /**
             * 远程搜索货位号编号绑定 货位类型
             */
            remoteMethodLcType(query) {
                if (query !== '') {
                    this.lcTypeLoading = true;

                    this.detailsSearch.lcCodeByLcType = query;
                    this.getLcCodeByFcCodeAndType();

                    setTimeout(() => {
                        this.lcTypeLoading = false;
                        if (this.lcCodeByLcTypeList != undefined) {
                            this.lcCodeByLcTypeList = this.lcCodeByLcTypeList.filter(item => {
                                return item.lcCode.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                            });
                        }
                    }, 200);
                } else {
                    this.lcCodeByLcTypeList = [];
                }
            },
            /**
             * 根据工厂编号和货位类型查询货位信息
             */
            getLcCodeByFcCodeAndType() {
                this.$http
                    .request({
                        url: "/api/location/getLaCodeAllByType",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            lcType: this.lcType,
                            //lcCode: this.lcTypeLcCode,
                            lcCode: this.detailsSearch.lcCodeByLcType
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.lcCodeByLcTypeList = resp.data.list
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            /**
             * 获取所有的用户
             */
            getUserList() {
                this.$http
                    .request({
                        url: "/api/user/userAll",
                        method: "GET",
                        params: {},
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.userList = resp.data.list;
                            this.logRemarks = "checkTask：查询用户操作成功";
                        } else {
                            this.logRemarks = "checkTask：查询用户操作失败";
                        }
                        // this.logContent = "sckCode：" + this.checkListMain[0].sckCode;
                        // this.systemLog();
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            /**
             * 判断盘点单是否全部盘点完成
             */
            getJudgeNotCounted() {
                this.$http
                    .request({
                        url: "/api/pda/getJudgeNotCounted",
                        method: "PUT",
                        showLoading: true,
                        params: {
                            sckCode: this.checkListMain[0].sckCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.judgeNotCounted = "该盘点单已全部盘点完,"
                        } else {
                            this.judgeNotCounted = "该盘点单还存在为盘点的,"
                        }
                        this.completeInventory();
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            complete() {
                this.getJudgeNotCounted();
            },
            //完成
            completeInventory() {
                // this.getJudgeNotCounted();
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请选择盘点计划",
                        type: "warning",
                    });
                    return;
                } else if (this.checkListMain.length != 1) {
                    this.$message({
                        message: "只能对一个盘点计划进行完成",
                        type: "warning",
                    });
                    return;
                } else if (this.checkListMain[0].sckStatus != "EXECUTE" && this.checkListMain[0].sckStatus != "LSSUED") {
                    this.$message({
                        message: "只能对已下发和进行中状态的盘点计划进行盘点完成",
                        type: "warning",
                    });
                    return;
                } else {
                    this.$confirm(this.judgeNotCounted + "是否完成盘点计划?", "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.$http
                                .request({
                                    url: "/api/checkTask/completeInventory",
                                    method: "PUT",
                                    showLoading: true,
                                    params: {
                                        person: localStorage.getItem("user")
                                    },
                                    data: this.checkListMain[0],
                                })
                                .then((resp) => {
                                    if (resp.status == 100) {
                                        this.$message({
                                            message: "盘点完成！",
                                            type: "success",
                                        });
                                        this.logRemarks = "checkTask：盘点计划（完成盘点）";
                                    } else {
                                        this.$message({
                                            message: "盘点完成！" + resp.message,
                                            type: "success",
                                        });
                                        this.logRemarks = "checkTask：盘点计划（完成盘点）";
                                    }
                                    this.closeDetailUpdateShow();
                                    this.logContent = "sckCode：" + this.checkListMain[0].sckCode;
                                    this.systemLog();
                                })
                                .catch((error) => {
                                    this.$message({
                                        message: "操作失败:" + error.message,
                                        type: "warning",
                                    });
                                });
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });
                }
            },
            //取消完成
            cancelCompleteInventory() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请选择盘点计划",
                        type: "warning",
                    });
                    return;
                } else if (this.checkListMain.length != 1) {
                    this.$message({
                        message: "只能对一个盘点计划取消完成",
                        type: "warning",
                    });
                    return;
                } else if (this.checkListMain[0].sckStatus != "COMPLETE" && this.checkListMain[0].sckStatus != 'HANDLE') {
                    this.$message({
                        message: "只能对完成或待处理状态的盘点计划取消完成",
                        type: "warning",
                    });
                    return;
                } else {
                    this.$confirm("是否取消完成盘点计划?", "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.$http
                                .request({
                                    url: "/api/checkTask/cancelCompleteInventory",
                                    method: "PUT",
                                    showLoading: true,
                                    data: this.checkListMain[0],
                                })
                                .then((resp) => {
                                    if (resp.status == 100) {
                                        this.$message({
                                            message: "操作成功",
                                            type: "success",
                                        });
                                        this.logRemarks = "checkTask：盘点计划（取消完成）";
                                        this.getStockCheckTaskList();
                                    } else {
                                        this.$message({
                                            message: resp.message,
                                            type: "error",
                                        });
                                        this.logRemarks = "checkTask：盘点计划（取消完成）";
                                    }
                                    this.logContent = "sckCode：" + this.checkListMain[0].sckCode;
                                    this.systemLog();
                                })
                                .catch((error) => {
                                    this.$message({
                                        message: "操作失败:" + error.message,
                                        type: "warning",
                                    });
                                });
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });
                }
            },
            //解决下拉框有值选择不了
            change() {
                this.$forceUpdate()
            },
            //打开盘点修改弹窗
            clickTaskUpdate() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请选择盘点计划",
                        type: "warning",
                    });
                    return;
                }
                if (this.checkListMain.length > 1) {
                    this.$message({
                        message: "有且只能选择一个盘点计划",
                        type: "warning",
                    });
                    return;
                }

                if (this.checkListMain[0].sckStatus != "EXECUTE" && this.checkListMain[0].sckStatus != "LSSUED") {
                    this.$message({
                        message: "只能对已下发或进行中状态的盘点计划进行修改",
                        type: "warning",
                    });
                    return;
                }

                this.detailUpdateShow = true;
                this.checkData = this.checkListMain[0];
                this.detailsSearch.sckCode = this.checkListMain[0].sckCode;
                this.getLcCodeByFcCodeAndType();
                this.getStockCheckTaskDetailList();
                this.detailData = {
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                };
            },
            //关闭盘点修改弹窗
            closeDetailUpdateShow() {
                this.detailUpdateShow = false;
                this.resetDetail();
                this.getStockCheckTaskList();
            },
            //打开重新盘点弹窗
            clickReloadTask() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请选择盘点计划",
                        type: "warning",
                    });
                    return;
                }
                if (this.checkListMain.length > 1) {
                    this.$message({
                        message: "有且只能选择一个盘点计划",
                        type: "warning",
                    });
                    return;
                }
                if (this.checkListMain[0].sckStatus != "COMPLETE" && this.checkListMain[0].sckStatus != "HANDLE") {
                    //console.log(this.checkListMain[0].sckStatus)
                    this.$message({
                        message: "只能对待处理和完成状态的盘点计划进行重新盘点！",
                        type: "warning",
                    });
                    return;
                }

                this.reloadCheckShow = true;
            },
            /**
             * 重新盘点
             */
            reloadCheckTask() {
                var searchTime = "";
                if (this.relaodCheckTime == undefined || this.relaodCheckTime.length != 2) {
                    this.$message({
                        message: "请选择重新盘点时间再进行盘点",
                        type: "warning",
                    });
                    return;
                }

                if (this.relaodCheckTime.length > 0) {
                    searchTime = this.relaodCheckTime[0] + "," + this.relaodCheckTime[1];
                }

                this.$confirm("是否重新盘点?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/checkTask/reloadCheckTask",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    sckCode: this.checkListMain[0].sckCode,
                                    sckTime: searchTime,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "checkTask：盘点计划（重新盘点）";
                                    this.reloadCheckShow = false;
                                    this.getStockCheckTaskList();
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "checkTask：盘点计划（重新盘点）";
                                }
                                this.logContent = "sckCode：" + this.checkListMain[0].sckCode;
                                this.systemLog();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            //校验新增盘盈记录
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            /**
             * 新增盘盈
             */
            insertInventory() {
                if (this.submitForm("insertInventoryData")) {
                    this.$confirm("是否确认进行新增盘盈操作?", "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.$http
                                .request({
                                    url: "/api/stockCheckTaskDetail/insertInventory",
                                    method: "POST",
                                    showLoading: true,
                                    params: {
                                        sckCode: this.checkListMain[0].sckCode,
                                        person: this.person,
                                        personNumber: this.personNumber,
                                    },
                                    data: this.insertInventoryData,
                                })
                                .then((resp) => {
                                    if (resp.status == 100) {
                                        this.$message({
                                            message: "操作成功",
                                            type: "success",
                                        });
                                        this.logRemarks = "checkTask：盘点盘盈处理确认完成操作成功";
                                    } else {
                                        this.$message({
                                            message: resp.message,
                                            type: "error",
                                        });
                                        this.logRemarks = "checkTask：盘点盘盈处理确认完成操作失败";
                                    }
                                    this.logContent = "sckCodes：" + this.checkListMain[0].sckCode;
                                    this.systemLog();
                                    this.insertInventoryDialog = false;
                                    this.updateRecordProfitFlag(this.insertInventoryData.scdId)
                                    this.insertInventoryClose();
                                    this.WhCodeList = [];
                                    this.lcCodeList = [];

                                    this.getStockCheckTaskRecord();
                                    this.getStockCheckTaskDetailListNotProfitLoss();
                                })
                                .catch((error) => {
                                    this.$message({
                                        message: "操作失败",
                                        type: "error",
                                    });
                                });
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });
                }
            },
            /**
             * 根据用户工厂编号获取所有的库区
             */
            getSysWarehouseAllData() {
                this.$http
                    .request({
                        url: "/api/sysWarehouse/getSysWarehouseAll",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.WhCodeList = resp.data;
                            this.insertInventoryDialog = true;
                        }
                    })
                    .catch((error) => {
                        this.$notify({
                            message: "操作失败",
                            type: "danger",
                        });
                    });
            },
            /**
             * 根据用户工厂编号获取所有的库区
             */
            getSysWarehouseAllData2() {
                this.$http
                    .request({
                        url: "/api/sysWarehouse/getSysWarehouseAll",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.WhCodeList = resp.data;
                            this.insertTaskRecordDialog = true;
                        }
                    })
                    .catch((error) => {
                        this.$notify({
                            message: "操作失败",
                            type: "danger",
                        });
                    });
            },
            //获取库位
            openSysLocation() {
                this.lcCodeList = [];
                this.insertInventoryData.laCode = ""
                this.getSysLocationAll();
            },
            /**
             * 盘点处理远程搜索根据工厂编号获取所有的库位信息
             */
            remoteMethodInventoryLcCode(query) {
                if (query !== '') {
                    this.lcCodeLoading = true;

                    this.inventoryProcessingSearch.lcCode = query;
                    this.getSysLocationAllHandle();

                    setTimeout(() => {
                        this.lcCodeLoading = false;
                        if (this.lcCodeList != undefined) {
                            this.lcCodeList = this.lcCodeList.filter(item => {
                                return item.lcCode.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                            });
                        }
                    }, 200);
                } else {
                    this.lcCodeList = [];
                }
            },
            /**
             * 远程搜索根据工厂编号获取所有的库位信息
             */
            remoteMethodLcCode(query) {
                if (query !== '') {
                    this.lcCodeLoading = true;

                    this.lcCode = query;
                    this.getSysLocationAll();

                    setTimeout(() => {
                        this.lcCodeLoading = false;
                        if (this.lcCodeList != undefined) {
                            this.lcCodeList = this.lcCodeList.filter(item => {
                                return item.lcCode.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                            });
                        }
                    }, 200);
                } else {
                    this.lcCodeList = [];
                }
            },
            /**
             * 远程搜索根据工厂编号获取所有的通道信息
             */
            remoteMethodWhCode(query) {
                if (query !== '') {
                    this.whCodeLoading = true;

                    this.whCode = query;
                    this.getSysWarehouseAllData();

                    setTimeout(() => {
                        this.whCodeLoading = false;
                        if (this.WhCodeList != undefined) {
                            this.WhCodeList = this.WhCodeList.filter(item => {
                                return item.whCode.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                            });
                        }
                    }, 200);
                } else {
                    this.WhCodeList = [];
                }
            },
            /**
             * 盘点处理查询根据工厂编号和库区编号查询所有的库位
             */
            getSysLocationAllHandle() {
                this.$http
                    .request({
                        url: "/api/location/getLocations",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            //whCode: this.insertInventoryData.whCode,
                            lcCode: this.inventoryProcessingSearch.lcCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if (resp.data.total != 0) {
                                this.lcCodeList = resp.data.list;
                                //   var a = resp.data.list.map((e, i) => {
                                //     var temp = {};
                                //     temp.label = e.lcCode;
                                //     temp.value = e.lcCode;
                                //     return temp;
                                //   });
                                //   this.options.forEach((item, index) => {
                                //     if (item.value == whCode) {
                                //       this.options[index].children = a;
                                //     }
                                //   });
                            }
                        }
                    })
                    .catch((error) => {
                        this.$notify({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 根据工厂编号和库区编号查询所有的库位
             */
            getSysLocationAll() {
                this.$http
                    .request({
                        url: "/api/location/getLocations",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            //whCode: this.insertInventoryData.whCode,
                            lcCode: this.lcCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if (resp.data.total != 0) {
                                this.lcCodeList = resp.data.list;
                                //   var a = resp.data.list.map((e, i) => {
                                //     var temp = {};
                                //     temp.label = e.lcCode;
                                //     temp.value = e.lcCode;
                                //     return temp;
                                //   });
                                //   this.options.forEach((item, index) => {
                                //     if (item.value == whCode) {
                                //       this.options[index].children = a;
                                //     }
                                //   });
                            }
                        }
                    })
                    .catch((error) => {
                        this.$notify({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 根据物料编号自动填充物料描述
             */
            matCodeChange(item) {
                this.insertInventoryData.matName = item.mtName;
            },
            /**
             * 远程搜索物料编号
             */
            remoteMethod(query) {
                if (query !== '') {
                    this.loading = true;

                    this.detailsSearch.matCode = query;
                    this.getSysMaterial();

                    setTimeout(() => {
                        this.loading = false;
                        if (this.matCodes != undefined) {
                            this.matCodes = this.matCodes.filter(item => {
                                return item.mtCode.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                            });
                        }
                    }, 200);
                } else {
                    this.matCodes = [];
                }
            },
            /**
             * 根据工厂编号查询所有的物料编号
             */
            getSysMaterial() {
                this.$http
                    .request({
                        url: "/api/material/getMaterials",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            mtCode: this.detailsSearch.matCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.matCodes = resp.data.list;
                            this.logRemarks = "checkTask：查询物料编号操作成功";
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "error",
                            });
                            this.logRemarks = "checkTask：查询物料编号操作失败";
                        }
                        //this.logContent = "sckCodes：" + sckCodes;
                        this.systemLog();
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            /**
             * 关闭盘点计划
             */
            closeInventory() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请选择盘点计划",
                        type: "warning",
                    });
                    return;
                }
                if (this.checkListMain.length > 1) {
                    this.$message({
                        message: "有且只能选择一个盘点计划",
                        type: "warning",
                    });
                    return;
                }

                if (this.checkListMain[0].sckStatus == "PROCESSED") {
                    this.$message({
                        message: "不能对已处理状态的盘点计划进行关闭",
                        type: "warning",
                    });
                    return;
                }

                this.$confirm("是否确认对该盘点计划进行关闭?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/stockCheckTaskDetail/closeInventory",
                                method: "PUT",
                                showLoading: true,
                                params: {
                                    sckCode: this.checkListMain[0].sckCode,
                                    sckStatus: "CLOSE",
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.getStockCheckTaskList();
                                    this.$message({
                                        message: "盘点计划关闭成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "checkTask：盘点计划关闭操作成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "checkTask：盘点计划关闭操作失败";
                                }
                                //this.logContent = JSON.stringify();
                                this.systemLog();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "error",
                                });
                            });
                    })
                    .catch(() => {
                        this.notInventoryProcessList = [];
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });

            },
            //关闭盘点修改弹窗
            closeDetailUpdateShow() {
                this.detailUpdateShow = false;
                this.resetDetail();
                this.getStockCheckTaskList();
            },
            //打开重新盘点弹窗
            clickReloadTask() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请选择盘点计划",
                        type: "warning",
                    });
                    return;
                }
                if (this.checkListMain.length > 1) {
                    this.$message({
                        message: "有且只能选择一个盘点计划",
                        type: "warning",
                    });
                    return;
                }
                if (this.checkListMain[0].sckStatus != "COMPLETE" && this.checkListMain[0].sckStatus != "HANDLE") {
                    //console.log(this.checkListMain[0].sckStatus)
                    this.$message({
                        message: "只能对待处理和完成状态的盘点计划进行重新盘点！",
                        type: "warning",
                    });
                    return;
                }

                this.reloadCheckShow = true;
            },
            /**
             * 打开新增盘盈窗口
             */
            openInsertInventory(row) {
                this.setInventoryData(row);
                this.getSysMaterial();
                this.getSysWarehouseAllData();
                this.getSysLocationAll();
            },
            /**
             * 设置新增盘盈对象的默认值为空
             */
            setInventoryDataInit(){
                this.insertInventoryData = {
                    matCode: "",
                    matName: "",
                    batchNo: "",
                    matQuan: "",
                    boxBarcode: "",
                    whCode: "",
                    laCode: "",
                    wiStatus: "NORMAL",
                    matSpecs: "",
                    matLenValu: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    scdId: "", //用于存储临时变量
                    orderCode: "",
                }
            },
            /**
             * 设置新增盘盈对象的默认值
             */
            setInventoryData(row) {
                this.insertInventoryData = {
                    matCode: row.matCode,
                    matName: row.matName,
                    batchNo: row.batchNo,
                    matQuan: row.matQuan,
                    boxBarcode: row.boxBarcode,
                    whCode: row.whCode,
                    laCode: row.laCode,
                    wiStatus: "NORMAL",
                    matSpecs: row.matSpecs,
                    matCreateTime: row.matCreateTime,
                    matLenValu: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    scdId: row.scdId,
                    orderCode: row.orderCode,
                }
            },
            /**
             * 关闭新增盘盈窗口
             */
            insertInventoryClose() {
                this.insertInventoryDialog = false;
                this.resetInsertInventory();
                this.WhCodeList = [];
                this.lcCodeList = [];
                this.$refs['insertInventoryData'].resetFields();
                //this.$refs.insertInventoryData.clearValidata();
            },
            resetInsertInventory() {
                this.insertInventoryData = {
                    matCode: "",
                    matName: "",
                    batchNo: "",
                    matQuan: "",
                    boxBarcode: "",
                    whCode: "",
                    lcCode: "",
                    wiStatus: "NORMAL",
                    matSpecs: "",
                    matLenValu: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    scdId: "",
                }
                this.$refs.insertInventoryData.clearValidate();
            },
            // 执行盘点处理操作
            inventorySurplusAndLoss() {
                this.detailData.data.forEach((item) => {
                    if (item.dealFlag == false) {
                        this.notInventoryProcessList.push(item);
                    }
                })
                // console.log(this.notInventoryProcessList.length)
                if (this.notInventoryProcessList.length == 0) {
                    this.$message({
                        message: "该盘点计划明细全已盘点处理完成！",
                        type: "warning",
                    });
                    return;
                } else {
                    this.$confirm("是否确认进行盘点处理操作?", "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.inventorySurplusAndLossLoading = true;
                            this.$http
                                .request({
                                    url: "/api/stockCheckTaskDetail/inventorySurplusAndLoss",
                                    method: "POST",
                                    showLoading: true,
                                    params: {
                                        sckCode: this.checkListMain[0].sckCode,
                                        person: localStorage.getItem("user") || "",
                                        personNumber: localStorage.getItem("empNumber") || null,
                                    },
                                    data: this.notInventoryProcessList,
                                })
                                .then((resp) => {
                                    if (resp.status == 100) {
                                        this.$message({
                                            message: "盘点处理成功！",
                                            type: "success",
                                        });
                                        this.notInventoryProcessList = [];
                                        this.logRemarks = "checkTask：盘点处理确认完成操作成功";
                                    } else {
                                        this.$message({
                                            message: resp.message,
                                            type: "error",
                                        });
                                        this.notInventoryProcessList = [];
                                        this.logRemarks = "checkTask：盘点处理确认完成操作失败";
                                    }
                                    //this.logContent = JSON.stringify();
                                    this.inventorySurplusAndLossLoading = false;
                                    this.systemLog();
                                    this.getStockCheckTaskDetailListNotProfitLoss(
                                        this.checkListMain[0].sckCode
                                    );
                                })
                                .catch((error) => {
                                    this.inventorySurplusAndLossLoading = false;
                                    this.$message({
                                        message: "操作失败",
                                        type: "error",
                                    });
                                });
                        })
                        .catch(() => {
                            this.notInventoryProcessList = [];
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });
                }
            },
            /**
             * 执行盘盈操作库存
             */
            inventorySurplus(item) {
                this.$confirm("是否确认进行盘盈处理操作?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/stockCheckTaskDetail/inventorySurplus",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                },
                                data: item,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "checkTask：盘点盘盈处理确认完成操作成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "checkTask：盘点盘盈处理确认完成操作失败";
                                }
                                this.logContent = JSON.stringify(item);
                                this.systemLog();
                                this.getStockCheckTaskDetailListNotProfitLoss(
                                    this.checkListMain[0].sckCode
                                );
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "error",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            /**
             * 执行盘亏操作库存
             */
            inventoryLoss(item) {
                this.$confirm("是否确认进行盘亏处理操作?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/stockCheckTaskDetail/inventoryLoss",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                },
                                data: item,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "checkTask：盘点盘亏处理确认完成操作成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "checkTask：盘点盘亏处理确认完成操作失败";
                                }
                                this.logContent = JSON.stringify(item);
                                this.systemLog();
                                this.getStockCheckTaskDetailListNotProfitLoss(
                                    this.checkListMain[0].sckCode
                                );
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "error",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            //关闭盘点处理弹窗
            inventoryProcessingClose() {
                this.getStockCheckTaskList();
                this.getSysWarehouseAll();
                this.getSysMaterial();
                this.notInventoryProcessList = [];
                this.sckCodeList = ""
                this.inventoryProcessingDialog = false;
            },
            //打开盘点处理弹窗
            inventoryProcessingShow() {
                // if (this.checkListMain.length == 0) {
                //     this.$message({
                //         message: "请先完成盘点计划后勾选盘点计划！",
                //         type: "warning",
                //     });
                //     return;
                // }

                // if (this.checkListMain.length > 1) {
                //     this.$message({
                //         message: "只能选择一个盘点计划！",
                //         type: "warning",
                //     });
                //     return;
                // }

                // if (this.checkListMain[0].sckStatus != "HANDLE") {
                //     this.$message({
                //         message: "只能对待处理状态的盘点计划进行盘点处理！",
                //         type: "warning",
                //     });
                //     return;
                // }
                this.checkListMain.forEach((item)=>{
                    this.sckCodeList += item.sckCode + ",";
                })
                this.getSysLocationAll();
                this.getStockCheckTaskDetailListNotProfitLoss();
                this.getStockCheckTaskRecord();
                this.inventoryProcessingDialog = true;
            },
            /**
             * 根据盘点单号查询无盘盈的明细信息
             */
            getStockCheckTaskDetailListNotProfitLoss() {
                this.$http
                    .request({
                        url: "/api/checkTask/getStockCheckTaskDetailListNotProfitLoss",
                        method: "GET",
                        params: {
                            pageNum: this.inventoryProcessingList.nowPage || null,
                            pageSize: this.inventoryProcessingList.pageSize || null,
                            sckCode: this.sckCodeList || null,
                            whCode: this.inventoryProcessingSearch.whCode || null,
                            laCode: this.inventoryProcessingSearch.lcCode || null,
                            matCode: this.inventoryProcessingSearch.matCode || null,
                            batchNo: this.inventoryProcessingSearch.batchNo || null,
                            boxBarcode: this.inventoryProcessingSearch.boxBarcode || null,
                            person: this.inventoryProcessingSearch.person || null,
                            inventoryTime: this.inventoryProcessingSearch.inventoryTime || null,
                            status: this.inventoryProcessingSearch.status || null,
                            fcCode: localStorage.getItem("fcCode") || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.inventoryProcessingList.data = resp.data.list || [];
                            this.inventoryProcessingList.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 多条件查询盘点明细
             */
            getStockCheckTaskDetailData() {
                this.$http
                    .request({
                        url: "/api/stockCheckTaskDetail/getStockCheckTaskDetailData",
                        method: "GET",
                        params: {
                            sckCode: this.checkData.sckCode,
                            //whCode: this.checkData.whCode,
                            matCode: this.checkData.matCode,
                            batchNo: this.checkData.batchNo,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.detailData.data = resp.data.list || [];
                            this.detailData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 根据工厂编号查询所有的通道
             */
            getSysWarehouseAll() {
                this.$http
                    .request({
                        url: "/api/sysWarehouse/getSysWarehouseAll",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.warehouseList = resp.data;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            // 点击查询按钮 重置页号
            clickSelectList(newVal) {
                this.mainData.nowPage = 1;
                this.getStockCheckTaskList(newVal);
            },
            /**
             * 查询盘点计划
             */
            getStockCheckTaskList() {
                let status = "";
                //this.mainSearch.sckStatus = "";
                this.sckStatusList.forEach((item) => {
                    status += item + ","
                })
                // if (this.mainSearch.whCode == "") {
                //   this.whCodeId = localStorage.getItem("whCode") || "";
                // } else {
                //   this.whCodeId = this.mainSearch.whCode;
                // }
                this.$http
                    .request({
                        url: "/api/checkTask/getStockCheckTaskListNotCreate",
                        method: "GET",
                        params: {
                            // person: localStorage.getItem("user") || "",
                            fcCode: this.mainSearch.fcCode || null,
                            sckCode: this.mainSearch.sckCode || null,
                            whCode: this.mainSearch.whCode || null,
                            //sckStatus: this.mainSearch.sckStatus || null,
                            sckStatus: status || null,
                            sckType: this.mainSearch.sckType || null,
                            sckTypeSub: this.mainSearch.sckTypeSub || null,
                            sckWay: this.mainSearch.sckWay || null,
                            beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                            endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                            pageNum: this.mainData.nowPage,
                            pageSize: this.mainData.pageSize,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData.data = resp.data.list || [];
                            this.mainData.data.forEach((item) => {
                                if (item.sckTime != undefined) {
                                    item.sckTime = item.sckTime.replaceAll(",", "~")
                                }
                            })
                            this.mainData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            //点击查询按钮 重置页号
            clickSelectInventoryProcessingList() {
                this.inventoryProcessingList.nowPage = 1;
                this.getStockCheckTaskDetailListNotProfitLoss();
            },
            // 点击查询按钮 重置页号
            clickSelectDetailList(newVal) {
                this.detailData.nowPage = 1;
                this.getStockCheckTaskDetailList(newVal);
            },
            /**
             * 查询盘点计划明细
             */
            getStockCheckTaskDetailList() {
                this.$http
                    .request({
                        url: "/api/checkTask/getStockCheckTaskDetailList",
                        method: "GET",
                        params: {
                            sckCode: this.detailsSearch.sckCode || null,
                            matCode: this.detailsSearch.matCode || null,
                            matName: this.detailsSearch.matName || null,
                            batchNo: this.detailsSearch.batchNo || null,
                            fcCode: this.detailsSearch.fcCode || null,
                            status: this.detailsSearch.status || null,
                            boxBarcode: this.detailsSearch.boxBarcode || null,
                            whCode: this.detailsSearch.whCode || null,
                            beginTime: this.detailsSearch.date ?
                                this.detailsSearch.date[0] : null,
                            endTime: this.detailsSearch.date ?
                                this.detailsSearch.date[1] : null,
                            pageNum: this.detailData.nowPage,
                            pageSize: this.detailData.pageSize,
                            person: this.detailsSearch.person || null,
                            laCode: this.detailsSearch.lcCodeByLcType || null,
                            //pageSize: 200,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.detailData.data = resp.data.list || [];
                            this.detailData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            //获取统计盘点明细
            getStockCheckTaskDetailStatistics() {
                this.$http
                    .request({
                        url: "/api/stockCheckTaskDetail/getStockCheckTaskDetailStatistics",
                        method: "GET",
                        params: {
                            sckCode: this.detailsSearch.sckCode || null,
                            matCode: this.detailsSearch.matCode || null,
                            matName: this.detailsSearch.matName || null,
                            batchNo: this.detailsSearch.batchNo || null,
                            fcCode: this.detailsSearch.fcCode || null,
                            status: this.detailsSearch.status || null,
                            boxBarcode: this.detailsSearch.boxBarcode || null,
                            beginTime: this.detailsSearch.date ?
                                this.detailsSearch.date[0] : null,
                            endTime: this.detailsSearch.date ?
                                this.detailsSearch.date[1] : null,
                            pageNum: this.detailData.nowPage,
                            pageSize: this.detailData.pageSize,
                            //pageSize: 200,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.reportFormData.data = resp.data.list || [];
                            this.reportFormData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 详情
             */
            rowDetail(data) {
                this.detailShow = true;
                this.checkData = data;
                // this.checkData.whCode = "";
                // this.checkData.matCode = "";
                // this.checkData.batchNo = "";
                this.detailsSearch.sckCode = data.sckCode;
                this.getUserList();
                this.getStockCheckTaskDetailList();
                this.detailData = {
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                };
            },
            /**
             * 报表
             */
            rowReportForm(data) {
                this.reportFormShow = true;
                this.checkData = data;
                this.detailsSearch.sckCode = data.sckCode;
                this.getStockCheckTaskDetailStatistics();
            },
            detailClose() {
                this.detailShow = false;
                this.resetDetail();
                this.getStockCheckTaskList();
            },
            /**
             * 关闭报表
             */
            reportFormClose() {
                this.reportFormShow = false;
            },

            // getWarehouse() {
            //   this.$http
            //     .request({
            //       url: "/api/warehouse/getWarehouse",
            //       method: "GET",
            // showLoading: true,
            //       params: {
            //         fcCode: localStorage.getItem("fcCode") || "",
            //         whCode: localStorage.getItem("whCode") || "",
            //       },
            //     })
            //     .then((resp) => {
            //       if (resp.status == 100) {
            //         this.warehouseList = resp.data.list || [];
            //       }
            //     })
            //     .catch((error) => {
            //       this.loading++;
            //     });
            // },
            /**
             * 多选
             */
            checkTableMain(val) {
                this.checkListMain = val;
            },
            /**
             * 盘点处理多选
             */
            checkInventoryMain(val) {
                this.checkInventorMain = val;
            },
            /**
             * 禁选
             */
            // checkboxMain(row, rowIndex) {
            //   //row.sckStatus == "EXECUTE"
            //   if (row.sckStatus == "HANDLE") {
            //     return true; // 不禁用
            //   } else {
            //     return false; // 禁用
            //   }
            // },
            /**
             * 重置
             */
            resetMain() {
                this.mainSearch = {
                    fcCode: localStorage.getItem("fcCode") || "",
                    sckCode: "",
                    whCode: "",
                    sckStatus: "",
                    sckType: "",
                    sckTypeSub: "",
                    sckWay: "",
                    date: [],
                };
                this.sckStatusList = ["LSSUED","EXECUTE","HANDLE"]
            },
            resetDetail() {
                this.detailsSearch = {
                    sckCode: "",
                    matCode: "",
                    matName: "",
                    batchNo: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    status: "",
                    boxBarcode: "",
                    date: [],
                };
            },

            resetStock() {
                this.checkData = {
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    whCode: "", // 通道编号
                    matCode: "", // 物料编号
                    matName: "", // 物料描述
                    sckDept: "", //盘点部门
                    sckPerson: "", //盘点人员
                    sckTime: "",
                    盘点时间,
                };
            },
            /**
             * 重置
             */
            resetInventoryProcessingSearch() {
                this.inventoryProcessingSearch = {
                    sckCode: "",
                    whCode: "",
                    lcCode: "",
                    matCode: "",
                    matName: "",
                    batchNo: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    boxBarcode: "",
                    person: "",
                    inventoryTime: "",
                    status:"",
                };
            },

            /**
             * 开始执行
             */
            // startExecutionTask() {
            //   if (this.checkListMain.length == 0) {
            //     this.$message({
            //       message: "请勾选盘点计划！",
            //       type: "warning",
            //     });
            //     return;
            //   }

            //   if (this.checkListMain.length > 1) {
            //     this.$message({
            //       message: "只能选择一个盘点计划！",
            //       type: "warning",
            //     });
            //     return;
            //   }

            //   this.$confirm("是否开始执行盘点计划?", "提示", {
            //     confirmButtonText: "确认",
            //     cancelButtonText: "取消",
            //     type: "warning",
            //   })
            //     .then(() => {
            //       this.$http
            //         .request({
            //           url: "/api/checkTask/startExecutionTask",
            //           method: "PUT",
            // showLoading: true,
            //           params: {
            //             sckCode: this.checkListMain[0].sckCode,
            //             person: localStorage.getItem("user") || "",
            //           },
            //         })
            //         .then((resp) => {
            //           if (resp.status == 100) {
            //             this.$message({
            //               message: "操作成功",
            //               type: "success",
            //             });
            //             this.logRemarks = "checkTask：盘点执行开始执行操作成功";
            //           } else {
            //             this.$message({
            //               message: resp.message,
            //               type: "error",
            //             });
            //             this.logRemarks = "checkTask：盘点执行开始执行操作失败";
            //           }
            //           this.logContent = "sckCode：" + this.checkListMain[0].sckCode;
            //           this.systemLog();
            //           this.getStockCheckTaskList();
            //         })
            //         .catch((error) => {
            //           this.$message({
            //             message: "操作失败",
            //             type: "error",
            //           });
            //         });
            //     })
            //     .catch(() => {
            //       this.$message({
            //         type: "info",
            //         message: "已取消",
            //       });
            //     });
            // },

            /**
             * 确认真实数量
             */
            confirmDetail(row) {
                if (row.matQuanReal == undefined) {
                    this.$message({
                        message: "请填写盘点数量",
                        type: "warning",
                    });
                    return;
                } else {
                    this.$http
                        .request({
                            url: "/api/checkTask/updateStockCheckTaskDetail",
                            method: "PUT",
                            showLoading: true,
                            params: {
                                person: localStorage.getItem("user"),
                            },
                            data: row,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                });
                                this.logRemarks = "checkTask：盘点执行确认真实数量操作成功";
                            } else {
                                this.$message({
                                    message: resp.message,
                                    type: "error",
                                });
                                this.logRemarks = "checkTask：盘点执行确认真实数量操作失败";
                            }
                            this.logContent = "盘点单号：" + row.sckCode;
                            this.systemLog();
                            this.getStockCheckTaskDetailList();
                        })
                        .catch((error) => {
                            this.$message({
                                message: "操作失败",
                                type: "error",
                            });
                        });
                }
            },

            /**
             * 确认盘点
             */
            confirmCheckTask() {
                this.closeDetailUpdateShow();
                this.$message({
                    message: "保存成功",
                    type: "success",
                });
                //let sckCodes = row.sckCode;
                // let sckCodes = this.detailData.data[0].sckCode;
                // this.$confirm("是否确认完成盘点?", "提示", {
                //         confirmButtonText: "确认",
                //         cancelButtonText: "取消",
                //         type: "warning",
                //     })
                //     .then(() => {
                //         this.$http
                //             .request({
                //                 url: "/api/checkTask/confirmCheckTask",
                //                 method: "PUT",
                // showLoading: true,
                //                 params: {
                //                     sckCodes: sckCodes,
                //                     person: localStorage.getItem("user") || "",
                //                 },
                //             })
                //             .then((resp) => {
                //                 if (resp.status == 100) {
                //                     this.closeDetailUpdateShow();
                //                     this.$message({
                //                         message: "操作成功",
                //                         type: "success",
                //                     });
                //                     this.logRemarks = "checkTask：盘点执行确认完成操作成功";
                //                 } else {
                //                     this.closeDetailUpdateShow();
                //                     this.$message({
                //                         message: resp.message,
                //                         type: "warning",
                //                     });
                //                     this.logRemarks = "checkTask：盘点执行确认完成操作失败";
                //                 }
                //                 this.logContent = "sckCodes：" + sckCodes;
                //                 this.systemLog();
                //                 this.getStockCheckTaskList();
                //             })
                //             .catch((error) => {
                //                 this.closeDetailUpdateShow();
                //                 this.$message({
                //                     message: "操作失败",
                //                     type: "error",
                //                 });
                //             });
                //     })
                //     .catch(() => {
                //         this.$message({
                //             type: "info",
                //             message: "已取消",
                //         });
                //     });
            },

            //表格导出
            downLoadFile() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请选择需要导出的盘点记录！",
                        type: "warning",
                    });
                    return
                }
                this.downloadLoading = true;
                let sckCodeList = [];
                for (let i in this.checkListMain) {
                    sckCodeList.push(this.checkListMain[i].sckCode);
                }
                let sckCode = sckCodeList.join(",");

                var paramsObj = {
                    sckCode: sckCode || null,
                    pageNum: 1,
                    pageSize: 999999,
                }
                this.$http.request({
                    url: '/api/checkTask/getStockCheckTaskDetailList',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    if(resp.data.total != 0 && resp.status == 100){
                        resp.data.list.forEach((item)=>{
                            if(item.status == 'EXECUTE'){
                                item.matQuanReal = "";
                                item.differenceValue = "";
                            }else{
                                item.differenceValue = item.matQuanReal - item.matQuan;
                            }
                        })
                    }
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.status == 'LSSUED') {
                            c['status'] = '已下发'
                        } else if (c.status == 'EXECUTE') {
                            c['status'] = '进行中'
                        } else if (c.status == 'HANDLE') {
                            c['status'] = '待处理'
                        } else if (c.status == 'COMPLETE') {
                            c['status'] = '完成'
                        } else if (c.status == 'PROCESSED') {
                            c['status'] = '完成'
                        } else if (c.status == 'CLOSE') {
                            c['status'] = '关闭'
                        }

                        if (c.profitFlag == true) {
                            c['profitFlag'] = '是'
                        } else if (c.profitFlag == false) {
                            c['profitFlag'] = '否'
                        }

                    })
                    const tHeader = ['通道编号', '库位编号', '盘点单号', '物料编号', '物料描述', '物料数量', '实际数量', '差异值', '批次号', '状态', '箱号', '订单编号',
                        '规值', '是否新增盘盈', '创建时间', '盘点人'
                    ]
                    const filterVal = ['whCode', 'laCode', 'sckCode', 'matCode', 'matName', 'matQuan', 'matQuanReal', 'differenceValue', 'batchNo', 'status', 'boxBarcode', 'orderCode',
                        'matSpecs', 'profitFlag', 'createTime', 'person'
                    ]
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '盘点计划单'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "stock_check_task：导出盘点计划记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },

            // //表格导出
            // downLoadFile() {
            //     this.downloadLoading = true;
            //     let status = "";
            //     //this.mainSearch.sckStatus = "";
            //     this.sckStatusList.forEach((item) => {
            //         status += item + ","
            //     })
            //     var paramsObj = {
            //         // person: localStorage.getItem("user") || "",
            //         fcCode: this.mainSearch.fcCode || null,
            //         sckCode: this.mainSearch.sckCode || null,
            //         whCode: this.mainSearch.whCode || null,
            //         //sckStatus: this.mainSearch.sckStatus || null,
            //         sckStatus: status || null,
            //         sckType: this.mainSearch.sckType || null,
            //         sckTypeSub: this.mainSearch.sckTypeSub || null,
            //         sckWay: this.mainSearch.sckWay || null,
            //         beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
            //         endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
            //         pageNum: 1,
            //         pageSize: 999999,

            //     }
            //     this.$http.request({
            //         url: '/api/checkTask/getStockCheckTaskListNotCreate',
            //         method: 'GET',
            //         params: paramsObj
            //     }).then((resp) => {
            //         resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
            //             message: '查询失败'
            //         });
            //     })
            // },
            // downLoad(list) {
            //     import('@/libs/Export2Excel').then(excel => {
            //         list.forEach(function(c) {
            //             if (c.sckStatus == 'LSSUED') {
            //                 c['sckStatus'] = '已下发'
            //             } else if (c.sckStatus == 'EXECUTE') {
            //                 c['sckStatus'] = '进行中'
            //             } else if (c.sckStatus == 'HANDLE') {
            //                 c['sckStatus'] = '待处理'
            //             } else if (c.sckStatus == 'COMPLETE') {
            //                 c['sckStatus'] = '完成'
            //             } else if (c.sckStatus == 'CLOSE') {
            //                 c['sckStatus'] = '关闭'
            //             }

            //             if (c.sckWay == '10') {
            //                 c['sckWay'] = '明盘'
            //             } else if (c.sckWay == '20') {
            //                 c['sckWay'] = '暗盘'
            //             }
            //         })
            //         const tHeader = ['盘点单号', '下发时间', '盘点状态', '盘点部门', '盘点人员', '盘点方式', '预计盘点时间', '创建时间', '操作人']
            //         const filterVal = ['sckCode', 'updateTime', 'sckStatus', 'sckDept', 'sckPerson', 'sckWay', 'sckTime', 'createTime', 'person']
            //         const data = this.formatJson(filterVal, list)
            //         excel.export_json_to_excel({
            //             header: tHeader,
            //             data,
            //             filename: '盘点执行单'
            //         })
            //         this.logContent = "导出"
            //         this.logRemarks = "stock_check_task：导出盘点执行记录"
            //         this.systemLog();
            //         this.downloadLoading = false
            //     })
            // },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "盘点执行",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            //this.getWarehouse();
            this.getSysWarehouseAll();
            this.getSysMaterial();
            /* 获取首页的数据 */
            this.getStockCheckTaskList();
        },
    };
</script>

<style scoped>
</style>
